/* eslint-disable max-len */
import Translation from './types'

const fi: Translation = {
  common: {
    like: 'Tykkäys',
    likes: 'Tykkäystä',
    makeComment: 'Kommentoi',
    comment: 'Kommentti',
    comments: 'Kommenttia',
    settings: 'Asetukset',
    yes: 'Kyllä',
    no: 'Ei',
    options: 'Vaihtoehto',
    active: 'Aktiivinen',
    in: '(missä)',
    time: 'Aika',
    hour: 'Tunti',
    minute: 'Minuutti',
    description: 'Kuvaus',
    profile: 'Profiili',
    loading: 'Ladataan...',
    newFeature: 'Uutuus!',
    showMore: 'Näytä enemmän',
    showLess: 'Näytä vähemmän',
    actions: {
      save: 'Tallenna',
      edit: 'Muokkaa',
      change: 'Muuta',
      delete: 'Poista',
      cancel: 'Peruuta',
      send: 'Lähetä',
      publish: 'Julkaise',
      update: 'Päivitä',
      confirm: 'Vahvista',
      create: 'Luo',
      add: 'Lisää',
      addMore: 'Lisää muita',
      remove: 'Poista',
      accept: 'Hyväksy',
      deny: 'Hylkää',
      continue: 'Jatka',
      leave: 'Poistu',
      join: 'Liity',
      skip: 'Ohita',
      select: 'Valitse',
      done: 'Selvä',
      close: 'Sulje',
      show: 'Näytä',
      tryAgain: 'Yritä uudelleen',
      later: 'Myöhemmin',
      logout: 'Kirjaudu ulos',
      back: 'Takaisin',
      invite: 'Kutsu',
      message: 'Tiedote',
      upload: 'Lataa',
      activate: 'Aktivoi',
      copyText: 'Kopioi teksti',
      print: 'Tulosta',
      report: 'Ilmoita',
      order: 'Tilaa',
      pay: 'Maksa',
      book: 'Varaa',
      saveChanges: 'Tallenna muutokset',
      clear: 'Tyhjennä',
      download: 'Lataa',
      bookAsAdmin: 'Varaa järjestelmänvalvojaksi',
      pin: 'Kiinnitä ylös',
      unpin: 'Poista kiinnitys',
    },
    form: {
      labels: {
        name: 'Nimi',
        surname: 'Sukunimi',
        email: 'Sähköpostiosoite',
        message: 'Tiedote',
        entrance: 'Osoite',
        entrance_samf: 'Tie',
        unit: 'Huoneiston numero',
        unit_samf: 'Kiinteistön nimi',
        unitRole: 'Rooli',
        active: 'Aktiivinen',
        organisationNumber: 'Yritystunnus',
        reference: 'Viite',
        society: 'Yhdistys',
        password: 'Salasana',
        role: 'Rooli',
        addressCity: 'Postitoimipaikka',
        addressZip: 'Postinumero',
        addressStreet: 'Katuosoite',
        addressCareOf: 'C/o',
        type: 'Tyyppi',
        from: 'Mistä',
        to: 'Mihin',
        discount: 'Alennus',
        gender: 'Sukupuoli',
        phoneNumber: 'Puhelinnumero',
        addressStreet1: 'Katuosoite 1',
        society_lgh: 'Kiinteistöjä',
      },
      helperTexts: {
        calculatedAutomatically: 'Lasketaan automaattisesti',
      },
      note: {
        required: '*Pakollinen',
        locked: 'Lukittu',
      },
      upload: {
        preparing: 'Valmistellaan...',
        uploading: 'Ladataan...',
        failedFiles: 'Seuraavia tiedostoja ei voitu ladata',
        success: 'Tiedostot ladattu',
        someFilesFailed: 'Jotkut tiedostot eivät onnistuneet latautumaan',
        invalidType: 'Tiedostotyyppiä ei tueta',
        fileTooLarge: 'Tiedosto on liian suuri',
        genericError: 'Ei voitu ladata',
      },
    },
    fee: {
      annually: 'Vuosittain',
      discountViaString: '{{ partnerName }} antama alennus',
    },
    boardDisabledFeature:
      'Yhdistys on päättänyt poistaa tämän ominaisuuden käytöstä.',
    copiedToClipboard: 'Kopioitu',
    unit: {
      unassigned: 'Ei jaettu',
    },
    // TODO: Update translations
    emptyState: {
      title: 'Ei ole mitään näytettävää.',
      subtitle: 'Tässä näkymässä ei ole tällä hetkellä mitään näytettävää!',
    },
    platform: {
      webapp: 'Verkkosovellus',
      mobileApp: 'Mobiilisovellus',
    },
    eventActions: {
      attendance: {
        attending: 'Tulossa',
        notAttending: 'Ei voi tulla',
        comment: 'Kommentti',
        updateComment: 'Päivittää Kommentti',
      },
    },
    contactActions: {
      call: 'Soita',
      email: 'Lähetä sähköpostia',
      website: 'Kotisivu',
    },
    contact: {
      phoneNumber: 'Puhelinnumero',
      email: 'Sähköpostiosoite',
      website: 'Kotisivu',
    },
    days: {
      singular: 'päivä',
      plural: 'päivää',
    },
    callout: {
      namedSocietyLocked: {
        title: '{{ societyName }} on lukittu',
      },
    },
    button: {
      save: 'Tallenna',
      send: 'Lähetä',
      delete: 'Poista',
      next: 'Seuraava',
      previous: 'Edellinen',
      close: 'Sulje',
      addMore: 'Lisää muita',
      toPayment: 'Maksuun',
    },
    other: 'Muu',
    none: 'Ei mitään',
    weekDays: {
      monday: 'Maanantai',
      tuesday: 'Tiistai',
      wednesday: 'Keskiviikko',
      thursday: 'Torstai',
      friday: 'Perjantai',
      saturday: 'Lauantai',
      sunday: 'Sunnuntai',
    },
    languages: {
      english: 'Englanti',
      swedish: 'Ruotsi',
    },
    prefixes: {
      you: 'Sinä',
    },
    notificationSettings: {
      label: 'Ilmoita asukkaalle',
      labelBoard: 'Ilmoita hallitukselle',
      none: 'Ei',
      feed: 'Fiidi',
      notificationAndFeed: 'Ilmoitukset ja fiidi',
      labelBoard_lgh: 'Ilmoita kiinteistöille',
      notification: 'Ilmoitus',
    },
    user: {
      deletedUserName: 'Poistettu käyttäjä',
      admin: 'Admin',
      masterAdmin: 'Pääkäyttäjä',
    },
    numberOfunits: {
      apartmentBuilding: 'Huoneistojen lukumäärä',
      boatClub: 'Asunnonomistajien lukumäärä',
      economicAssociation: 'Kiinteistöjen lukumäärä',
      homeownersAssociatoon: 'Kiinteistöjen lukumäärä',
      housingCooperative: 'Huoneistojen lukumäärä',
      housingCooperativeConstruction: 'Huoneistojen lukumäärä',
      neighbourhood: 'Kiinteistöjen lukumäärä',
      nonProfitAssociation: 'Kiinteistöjen lukumäärä',
      shared: 'Käyttäjien määrä',
    },
    errorViews: {
      userNotInSociety: {
        title: 'Ei ole yhdistyksen jäsen',
        subtitle:
          'Hae yhdistyksesi jäsenyyttä "Yhdistys"-välilehdeltä, jotta voit keskustella naapureidesi kanssa.',
        title_lgh: 'Ei vuokralainen kiinteistössä',
        subtitle_lgh:
          'Hae kiinteistösi jäsenyyttä "Kiinteistö"-välilehdeltä, jotta voit keskustella naapureidesi kanssa.',
      },
      pendingRequest: {
        title: 'Odotetaan vahvistusta hallitukselta',
      },
    },
    singularPlural: {
      years: {
        singular: 'Vuosi',
        plural: 'Vuosi',
      },
      unit: {
        singular: 'Huoneisto',
        plural: 'Huoneistot',
        singular_samf: 'Kiinteistö',
        plural_samf: 'Kiinteistöt',
      },
      like: {
        singular: 'Tykkäystä',
        plural: 'Tykkäystä',
      },
      connected: {
        singular: 'yhdistetty',
        plural: 'yhdistetty',
      },
      person: {
        singular: 'Henkilö',
        plural: 'Henkilöt',
      },
    },
    terms: {
      user: 'Käyttöehdot',
      service: 'Palveluehdot',
      dataProcessing: 'Henkilötietojen käsittely',
    },
    boardDisabledFeature_lgh:
      'Kiinteistö on päättänyt poistaa tämän ominaisuuden käytöstä.',
  },
  registerGuidanceView: {
    title_samf: 'Registrera en ny fastighetsguide',
    title: 'Rekisteröi uusi asunto-oikeus',
    subTitle_samf: 'Lisää oppaita kiinteistöösi',
    subTitle: 'Lisää oppaita yhdistykseesi',
    description: 'Opas on hyvä tapa antaa uusille asukkaille tärkeitä tietoja.',
    description_samf:
      'Opas on hyvä tapa antaa uusille asukkaille tärkeitä tietoja.',
    address:
      'hallitusportaalissa ja tarkista, että kaikki yhdistyksen osoitteet on lisätty.',
    address_samf:
      'hallitusportaalissa ja tarkista, että kaikki yhdistyksen tiet on lisätty.',
    link: 'Napsauta sitten “Kiinteistöt” ja lisää puuttuvat kiinteistötunnukset.',
    link_samf: 'Napsauta sitten “Asuntonumerot” ja lisää puuttuvat numerot.',
    ifMany:
      'Jos lisättäviä asuntonumeroita on paljon, helpointa on tehdä se verkkosovelluksessa Excel-tiedoston avulla.',
    ifMany_samf:
      'Jos lisättäviä kiinteistöjä on paljon, helpointa on tehdä se verkkosovelluksessa Excel-tiedoston avulla.',
    tips: 'Vinkki,',
    support: 'Ota yhteyttä tukeemme, jos tarvitset apua rekisterin kanssa.',
    goto: 'Siirry',
    register: 'Rekisteri',
    howToDo: 'Näin se tehdään',
  },
  blockedCallout: {
    message:
      'Sinulla ei ole lupaa julkaista sisältöä yhteisössä {{ societyNames }}.',
  },
  societyType: {
    housingCooperative: 'Asumisoikeusyhdistys',
    housingCooperativeConstruction: 'Projekti (kiinteistökehittäjä)',
    homeOwnersAssociation: 'Yhtymä',
    nonProfitAssociation: 'Aatteellinen yhdistys',
    economicAssociation: 'Osuuskunta',
    neighbourhood: 'Naapurusto',
    apartmentBuilding: 'Kerrostalo',
  },
  accordionSection: {
    defaultItemsEmptyText: 'Tämä osio on tyhjä',
  },
  select: {
    noOptions: 'Ei vaihtoehtoja',
  },
  offlineView: {
    title: 'Olet offline.',
    subtitle:
      'Tarkista internetyhteytesi ja yritä uudelleen lataamalla sivu uudelleen.',
  },
  notFoundView: {
    title: 'Oho! Olet käynyt sivulla, jota ei ole olemassa.',
    subtitle: 'Pahoittelemme. Napsauta Mene takaisin ja yritä uudelleen.',
    buttonLabel: 'Mene takaisin',
  },
  unauthorizedView: {
    title: 'Sinulla ei ole lupaa tarkastella tätä sivua.',
    subtitle:
      'Tämä johtuu siitä, että sinulla ei ole tarvittavaa roolia sisällön käyttämiseen.',
    buttonLabel: 'Mene takaisin',
  },
  chatView: {
    title: 'Chat',
  },
  chatMessageReadBy: {
    readBy: 'Lukenut',
    modalTitle: 'Tiedote luettu',
    more: 'ja {{count}} muuta',
  },
  chatRoom: {
    flashMessage: {
      noAccess: 'Sinulla ei ole enää pääsyä tähän keskusteluun',
    },
    composer: {
      notMember: 'Liity keskusteluun lähettääksesi viestejä',
    },
    emptyState: {
      noMessages: 'Ei viestejä vielä',
    },
  },
  registerView: {
    title: 'Rekisteröidy',
    upload: 'Lataa rekisteri',
    tabBar: {
      entrances: 'Osoitteet',
      entrances_samf: 'Tiet',
      unit: 'Huoneiston numero',
      unit_samf: 'Kiinteistöt',
      members: 'Jäsenet',
      members_lgh: 'Vuokralaiset',
      nonMembers: 'Muut käyttäjät',
      groups: 'Ryhmät',
    },
    unit: {
      labels: {
        entrance: 'Osoite',
        entrance_samf: 'Tie',
        unit: 'Huoneiston numero',
        unit_samf: 'Kiinteistö',
        title: 'Huoneiston numero (yhdistys)',
        title_samf: 'Osoite',
        titleLegal: 'Huoneiston numero (maanmittauslaitos)',
        titleLegal_samf: 'Kiinteistön nimi',
        floor: 'Kerros',
        title_lgh: 'Kiinteistökuva',
      },
      warnings: {
        noResidents: 'Tähän ei liity asukasta',
      },
    },
    group: {
      unitsSingular: 'huoneiston numero',
      unitsPlural: 'huoneiston numero',
      membersSingular: 'Jäsen',
      membersPlural: 'Jäsenet',
    },
    emptyState: {
      member: {
        title: 'Käyttäjiä ei sallittu.',
        noSearchResults: 'Hakutuloksia ei löytynyt.',
      },
    },
    alert: {
      removeUserTitle: 'Poista asukas',
      removeUserText: 'Haluatko poistaa {{ name }} yhdistyksestä?',
      removeUserText_lgh: 'Haluatko poistaa {{ name }} kiinteistöstä?',
      removeUserTitle_lgh: 'Poista kiinteistö',
    },
    flashMessage: {
      removeUserSuccess: 'Henkilö on poistettu yhdistyksestä',
      removeUserFailure: 'Henkilöä ei voitu poistaa yhdistyksestä',
      removeUserSuccess_lgh: 'Henkilö on poistettu kiinteistöstä',
      removeUserFailure_lgh: 'Henkilöä ei voitu poistaa kiinteistöstä',
    },
  },
  registerEntrance: {
    modal: {
      create: 'Lisää osoite',
      create_samf: 'Lisää tie',
      update: 'Päivitä osoite',
      update_samf: 'Päivitä tie',
    },
    form: {
      labels: {
        addressStreet: 'Osoite',
        addressStreet_samf: 'Tie',
      },
    },
    numberOfUnits:
      'Tähän osoitteeseen on {{ number }} {{ unitText }} {{connectText}}',
    numberOfUnits_samf:
      'Tähän tiehen on {{ number }} {{ unitText }} {{connectText}}',
    confirmationDialog: {
      deleteTitle: 'Poista osoite',
      deleteDescription: 'Haluatko varmasti poistaa osoitteen?',
      deleteTitle_samf: 'Poista tie',
      deleteDescription_samf: 'Haluatko varmasti poistaa tien?',
    },
    warnings: {
      unableDeleteWithUnits:
        'Osoitteita, joihin on linkitetty huoneiston numero, ei voi poistaa.',
      unableDeleteWithUnits_samf:
        'Teitä, joihin on linkitetty kiinteistöjä, ei voi poistaa.',
      unableToDeleteWithUnassigned:
        'Tätä osoitetta ei voi poistaa. Se sisältää ominaisuuden määrittelemätön -vaihtoehdon, jota voidaan käyttää käyttäjille, joilla ei ole määritettyä osoitetta.',
      unableToDeleteWithUnassigned_samf:
        'Tätä tietä ei voi poistaa. Se sisältää jakamaton kiinteistö -vaihtoehdon, jota voidaan käyttää käyttäjille, joilla ei ole määritettyä ominaisuutta.',
    },
    flashMessage: {
      createEntranceSuccess: 'Osoite luotu',
      createEntranceFailure: 'Osoitetta ei voitu luoda',
      updateEntranceSuccess: 'Osoite päivitetty',
      updateEntranceFailure: 'Osoitetta ei voitu päivittää',
      deleteEntranceSuccess: 'Osoite poistettu',
      deleteEntranceFailure: 'Osoitetta ei voitu poistaa',
      createEntranceSuccess_samf: 'Tie luotu',
      createEntranceFailure_samf: 'Tietä ei voitu luoda',
      updateEntranceSuccess_samf: 'Tie päivitetty',
      updateEntranceFailure_samf: 'Tietä ei voitu päivittää',
      deleteEntranceSuccess_samf: 'Tie poistettu',
      deleteEntranceFailure_samf: 'Tietä ei voitu poistaa',
    },
  },
  preApproved: {
    title: 'Kutsut',
    subtitle: 'Täältä näet kaikki kutsut, joihin ei ole vielä vastattu',
    buttons: {
      remindAllTitle: 'Muistuta kaikkia',
    },
    confirmationDialog: {
      deleteTitle: 'Peruuta kutsu',
      deleteDescription: 'Haluatko peruuttaa kutsun?',
      remindTitle: 'Lähetä muistutus',
      remindDescription: 'Haluatko lähettää muistutuksen?',
      remindAllTitle: 'Lähetä muistutus',
      remindAllDescription: 'Haluatko lähettää muistutuskutsun kaikille?',
    },
    flashMessage: {
      sendReminderFailure: 'Muistutusta ei voitu lähettää',
      sendReminderSuccess: 'Muistutus lähetetty',
      remindAllFailure: 'Muistutuksia ei voitu lähettää',
      remindAllSuccess: 'Kaikki muistutukset lähetetty',
      deletePreApprovedFailure: 'Kutsua ei voitu peruuttaa',
      deletePreApprovedSuccess: 'Kutsu peruutettu',
    },
  },
  registerUnit: {
    modal: {
      create: 'Lisää huoneiston numero',
      create_samf: 'Lisää kiinteistö',
      update: 'Päivitä huoneiston numero',
      update_samf: 'Päivitä kiinteistö',
      residents: 'Asukas',
      residents_lgh: 'Vuokralaiset',
    },
    confirmationDialog: {
      deleteTitle: 'Poista huoneiston numero',
      deleteDescription: 'Haluatko varmasti poistaa huoneiston numeron?',
      deleteTitle_samf: 'Poista kiinteistö',
      deleteDescription_samf: 'Haluatko varmasti poistaa kiinteistön?',
      deleteDescriptionWithBinder:
        'Haluatko varmasti poistaa huoneiston numeron? Huoneistoon on liitetty kansio.',
      deleteDescriptionWithBinder_samf:
        'Haluatko varmasti poistaa kiinteistön? Kiinteistöön on liitetty kansio.',
    },
    flashMessage: {
      createUnitFailure: 'Huoneiston numeroa ei voitu luoda',
      createUnitSuccess: 'Huoneiston numero luotu',
      updateUnitFailure: 'Huoneiston numeroa ei voitu päivittää',
      updateUnitSuccess: 'Huoneiston numero päivitetty',
      deleteUnitFailure: 'Huoneiston numeroa ei voitu poistaa',
      deleteUnitSuccess: 'Huoneiston numero poistettu',
      createUnitFailure_samf: 'Kiinteistöä ei voitu luoda',
      createUnitSuccess_samf: 'Kiinteistö luotu',
      updateUnitFailure_samf: 'Kiinteistöä ei voitu päivittää',
      updateUnitSuccess_samf: 'Kiinteistö päivitetty',
      deleteUnitFailure_samf: 'Kiinteistöä ei voitu poistaa',
      deleteUnitSuccess_samf: 'Kiinteistö poistettu',
    },
  },
  registerRequest: {
    modal: {
      title: 'Jäsenkyselyt',
    },
    flashMessage: {
      approveRequestSuccess: 'Tiedustelu hyväksytty',
      approveRequestFailure: 'Tiedustelua ei voitu hyväksyä',
      denyRequestSuccess: 'Tiedustelu hylätty',
      denyRequestFailure: 'Tiedustelua ei voitu hylätä',
    },
  },
  adminWebinar: {
    options: {
      gettingStarted: 'Aloita',
      intro: 'Johdanto',
      newBoard: 'Uusi hallituksen jäsen',
    },
  },
  registerExcelImport: {
    modal: {
      entranceUnitTitle: 'Huoneistorekisteri',
      entranceUnitTitle_samf: 'Kiinteistörekisteri',
      memberTitle: 'Jäsenrekisteri',
      memberTitle_lgh: 'Jäsenrekisteri',
      entranceUnitSubtitle: 'Päivitä huoneistorekisteri',
      entranceUnitSubtitle_samf: 'Päivitä kiinteistörekisteri',
      entranceUnitDescription:
        'Paras tapa muokata useita kiinteistöjä on ladata rekisteri Exceliin, tehdä siellä muutokset ja ladata se sitten takaisin Boappaan.',
      entranceUnitDescription_samf:
        'Paras tapa muokata useita kiinteistöjä on ladata rekisteri Exceliin, tehdä muutoksia siellä ja ladata se sitten takaisin Boappaan.',
      memberSubtitle: 'Päivitä jäsenrekisteri',
      memberDescription:
        '1. Lataa ja täytä asunnonomistajien nimet ja sähköpostiosoitteet\n\n2. Lataa Excel-tiedosto ja napsauta Tallenna\n\n3. Jäsenesi kutsutaan automaattisesti ja yhdistetään huoneistoihinsa. Jäsenet, jotka on jo kutsuttu Boappaan, eivät saa uutta kutsua',
      memberSubtitle_lgh: 'Päivitä vuokralaisrekisteri',
      memberDescription_lgh:
        '1. Lataa ja täytä vuokralaisten nimet ja sähköpostiosoitteet\n\n2. Lataa Excel-tiedosto ja napsauta Tallenna\n\n3. Vuokralaisesi kutsutaan automaattisesti ja yhdistetään huoneistoihinsa. Vuokralaiset, jotka on jo kutsuttu Boappaan, eivät saa uutta kutsua',
    },
    flashMessage: {
      uploadRegisterSuccess: 'Rekisteri ladattu',
      uploadRegisterFailure: 'Rekisteriä ei voitu ladata',
    },
  },
  registerInvite: {
    modal: {
      inviteMember: 'Kutsu asunnonomistaja',
      inviteMember_lgh: 'Kutsu vuokralainen',
      inviteNonMember: 'Kutsu muita käyttäjiä',
    },
    form: {
      unit: 'Huoneiston numero',
      unit_samf: 'Kiinteistö',
      inviteWithoutUnit: 'Bjud in utan bostad',
      inviteWithoutUnit_samf: 'Kutsu ilman asuinpaikkaa',
      unitMissingMessage: 'Määrittämätön asuinpaikka puuttuu kohteelle ',
      unitMissingMessage_samf: 'Määrittämätön kiinteistö puuttuu kohteelle ',
      inviteAsAdmin: 'Kutsu järjestelmänvalvojana',
      inviteAsBoard: 'Kutsu hallituksen jäsenenä',
      inviteAsBoard_lgh: 'Kutsu isännöitsijänä',
    },
    flashMessage: {
      inviteSentFailure: 'Kutsua ei voitu lähettää',
      inviteSentSuccess: 'Kutsu lähetetty',
    },
  },
  registerGroup: {
    modal: {
      create: 'Luo ryhmä',
      update: 'Päivitä ryhmä',
    },
    form: {
      labels: {
        name: 'Ryhmän nimi',
      },
      options: {
        type: {
          unit: 'Huoneisto',
          unit_samf: 'Kiinteistö',
          user: 'Käyttäjä',
        },
      },
    },
    confirmationDialog: {
      deleteTitle: 'Poista ryhmä',
      deleteDescription: 'Haluatko varmasti poistaa ryhmän?',
      changeTypeTitle: 'Päivitä tyyppi',
      changeTypeDescription:
        'Olemassa olevan ryhmätyypin valinnat poistetaan. Haluatko varmasti vaihtaa ryhmän tyyppiä?',
    },
    flashMessage: {
      deleteSuccess: 'Ryhmä poistettu',
      deleteFailure: 'Ryhmää ei voitu poistaa',
      createSuccess: 'Ryhmä luotu',
      createFailure: 'Ryhmää ei voitu luoda',
      updateSuccess: 'Ryhmä päivitetty',
      updateFailure: 'Ryhmää ei voitu päivittää',
    },
  },
  gdprView: {
    title: 'GDPR',
    content:
      'Boappa arvostaa tietosuojaa ja yksityisyyttä. Työskentelemme jatkuvasti varmistaaksemme, että käyttäjiemme henkilötietoja käsitellään oikein ja autamme yhdistystänne suojaamaan jäsenten henkilötietoja. Henkilötietojen käsittelyä koskeva oikeudellinen kehys on yleinen tietosuoja-asetus (GDPR). \n\nAlta löydät Boappan tietosuojavastaavan tiedot, vinkit ja yhteystiedot.',
    moreAbout: {
      title: 'Lisätietoja GDPR:stä',
    },
    personalDataAdvice: {
      title: 'Vinkkejä henkilötietojesi käsittelyyn',
    },
    boappaVendor: {
      title: 'Alihankkijat',
      description:
        'Tämä on luettelo alihankkijoista, joita Boappa AB käyttää Boappa-palvelun toimittamiseen. Kaikki alihankkijat ovat hyväksyneet toiminnan GDPR:n mukaisesti.',
      vendors: {
        billogram: {
          name: 'Billogram',
          description: 'palvelu, jota käytetään laskujen lähettämiseen.',
        },
        mailchimp: {
          name: 'Mailchimp',
          description: 'palvelu lähtevän sähköpostin lähettämiseen.',
        },
        firebase: {
          name: 'Google Firebase',
          description:
            'palvelu, jota käytetään ilmoitusten lähettämiseen mobiilisovelluksessa.',
        },
        cloudflare: {
          name: 'Cloudfare',
          description:
            'palvelu, jota käytetään palvelun sisällön toimittamiseen sovellukseen.',
        },
        aws: {
          name: 'Amazon Web Services',
          description:
            'Pilvipalvelu, jota käytetään sovelluksen infrastruktuurin hallintaan ja tietojen tallentamiseen.',
        },
      },
    },
    dataProtectionOfficer: {
      title: 'Tietosuojavastaava',
    },
    content_lgh:
      'Boappa arvostaa tietosuojaa ja yksityisyyttä. Työskentelemme jatkuvasti varmistaaksemme, että käyttäjiemme henkilötietoja käsitellään oikein ja autamme teitä kiinteistönä suojaamaan asukkaidenne henkilötietoja. Henkilötietojen käsittelyä koskeva oikeudellinen kehys on yleinen tietosuoja-asetus (GDPR). \n\nAlta löydät Boappan tietosuojavastaavan tiedot, vinkit ja yhteystiedot.',
  },
  societyInformationView: {
    title: 'Tietoja yhdistyksestä',
    formSections: {
      societyPicture: 'Yhdistyksen kuva',
      societyTitle: 'Yhdistys',
      addressTitle: 'Osoite',
      societyPicture_lgh: 'Kiinteistön kuva',
      societyTitle_lgh: 'Kiinteistö',
    },
    labels: {
      updateSocietyPicture: 'Päivitä kuva',
    },
    title_lgh: 'Tietoja kiinteistöstä',
  },
  societyContractsView: {
    title: 'Sopimus',
    emptyState: {
      title: 'Sopimuksia ei ole',
      subtitle: 'Yhdistykseen ei ole lisätty sopimuksia.',
      noSearchResultsTitle: 'Sopimuksia ei löytynyt',
      noSearchResultsSubtitle: 'Muuta hakutermiä ja yritä uudelleen.',
      subtitle_lgh: 'Kiinteistölle ei ole lisätty yhteystietoja.',
    },
  },
  societyBoardMembersView: {
    title: 'Hallituksen jäsenet',
    title_lgh: 'Isännöitsijät',
    emptyState: {
      title: 'Hallituksen jäsenet',
      title_lgh: 'Isännöitsijät',
      subtitle: 'Hallituksen jäseniä ei ole lisätty yhdistykseen.',
      subtitle_lgh: 'Kiinteistölle ei ole lisätty yhteystietoja.',
      noSearchResultsTitle: 'Hallituksen jäseniä ei löytynyt',
      noSearchResultsSubtitle: 'Muuta hakutermiä ja yritä uudelleen.',
    },
  },
  societyContractDetailView: {
    emptyState: {
      title: 'Sopimusta ei löytynyt',
      subtitle: 'Yritit tehdä sopimuksen, jota ei ole olemassa.',
    },
  },
  societyStatisticsExportsView: {
    title: 'Tilastot ja otteet',
    tabBar: {
      statistics: 'Tilastot',
      exports: 'Ote',
    },
    statistics: {
      headerTitle: 'Aktiviteetti',
      numberLogins: 'Kirjautuneiden käyttäjien kokonaismäärä',
      numberPosts: 'Fiidijulkaisujen kokonaismäärä',
      numberLikes: 'Tykkäyksiä yhteensä',
      numberComments: 'Kommenttien kokonaismäärä',
    },
    exports: {
      residentList: {
        headerTitle: 'Asukas',
        headerTitle_lgh: 'Vuokralaiset',
        residentListDownload: 'Asukasluettelo',
        residentListDownload_lgh: 'Vuokralaisluettelo',
      },
      bookingsList: {
        headerTitle: 'Tilavaraukset',
      },
    },
  },
  contactsView: {
    title: 'Yhteystiedot',
    emptyState: {
      title: 'Ei yhteystietoja',
      subtitle: 'Yhteystietoja ei ole lisätty yhdistykseen.',
      subtitle_lgh: 'Kiinteistölle ei ole lisätty yhteystietoja.',
      noSearchResultsTitle: 'Yhteystietoja ei löytynyt',
      noSearchResultsSubtitle: 'Muuta hakutermiä ja yritä uudelleen.',
    },
  },
  societyView: {
    title: 'Yhdistys',
    title_lgh: 'Kiinteistö',
    emptyState: {
      noSociety: {
        title: 'Ei ole yhdistyksen jäsen',
        subtitle:
          'Hae yhdistyksesi jäseneksi napsauttamalla alla olevaa painiketta.',
        buttonTitle: 'Etsi yhdistys',
        title_lgh: 'Ei kiinteistön jäsen',
        subtitle_lgh:
          'Hae liittyäksesi kiinteistöösi napsauttamalla alla olevaa painiketta.',
        buttonTitle_lgh: 'Etsi kiinteistö',
      },
      pendingRequest: {
        title: 'Odotetaan vahvistusta hallitukselta',
        title_lgh: 'Odotetaan vahvistusta isännöitsijältä',
        subtitle: 'Täältä saat kattavat tiedot yhdistyksestäsi',
        subtitle_lgh: 'Täällä voit saada tietoa kiinteistöstäsi',
        buttonTitle: 'Etsi yhdistys',
        buttonTitle_lgh: 'Etsi kiinteistö',
      },
    },
  },
  binderListView: {
    title: 'Talokansio',
  },
  residentListView: {
    title: 'Asukasluettelo',
    joined: 'Liittyi',
  },
  adminRightsView: {
    title: 'Ylläpito-oikeudet',
    makeMasterAdminTitle: 'Tee pääkäyttäjäksi',
    flashMessage: {
      adminRemoveSuccess: 'Ylläpitäjä poistettu',
      adminRemoveFailure: 'Ylläpitäjää ei voitu poistaa',
      masterAdminChangedSuccess: 'Pääkäyttäjä vaihtui',
      masterAdminChangedFailure: 'Pääkäyttäjää ei voitu vaihtaa',
    },
    alert: {
      deleteAdminTitle: 'Poista ylläpitäjä',
      deleteAdminText: 'Haluatko varmasti poistaa ylläpitäjän?',
      updateMasterAdminTitle: 'Päivitä pääkäyttäjä',
      updateMasterAdminText: 'Haluatko varmasti vaihtaa pääkäyttäjän?',
    },
    emptyState: {
      title: 'Ei ylläpitäjiä',
      subtitle: 'Tällä hetkellä luettelossa ei ole ylläpitäjiä',
      noSearchResultsTitle: 'Yhtään ylläpitäjää ei löytynyt',
      noSearchResultsSubtitle: 'Muuta hakutermiä ja yritä uudelleen.',
    },
  },
  boardContactsView: {
    title: 'Hallituksen yhteystiedot',
    title_lgh: 'Isännöitsijän yhteystiedot',
    emptyState: {
      title: 'Ei yhteystietoja',
      subtitle: 'Yhteystietoja ei ole lisätty yhdistykseen.',
      subtitle_lgh: 'Kiinteistölle ei ole lisätty yhteystietoja.',
      noSearchResultsTitle: 'Yhteystietoja ei löytynyt',
      noSearchResultsSubtitle: 'Muuta hakutermiä ja yritä uudelleen.',
    },
  },
  boardCalendarView: {
    title: 'Hallituksen kalenteri',
    title_lgh: 'Kiinteistön kalenteri',
    emptyState: {
      title: 'Ota rennosti, kalenterissa ei ole varauksia.',
      subtitle: 'Tällä hetkellä ei ole suunniteltuja kalenteritapahtumia.',
    },
  },
  contactCard: {
    flashMessage: {
      deleteContactSuccess: 'Yhteystieto poistettu',
      deleteContactFailure: 'Yhteystietoa ei voitu poistaa',
    },
    alert: {
      deleteContactTitle: 'Poista yhteystieto',
      deleteContactText: 'Haluatko varmasti poistaa yhteystiedon?',
    },
    call: 'Puhelin:',
    email: 'Sähköposti:',
    website: 'Verkkosivusto:',
  },
  marketplaceListView: {
    title: 'Osta & myy',
    subtitle: 'Osta, myy, vuokraa ja lainaa',
    emptyState: {
      title: 'Ilmoitusta ei ole vielä lähetetty',
      subtitle:
        'Julkaise mainos aloittaaksesi Osta ja myy -sivun. Voit helposti poistaa ilmoituksen myöhemmin, jos muutat mieltäsi.',
      subtitleMissingUnit:
        'Ilmoituksen luomiseksi sinun tulee olla asukas yhdistyksessä.',
      subtitleMissingUnit_lgh:
        'Ilmoituksen luomiseksi sinun tulee kuulua kiinteistössä olevaan asuntoon.',
    },
    noListingFound: {
      title: 'Yksikään ilmoitus ei vastannut hakuasi',
      subtitle:
        'Kokeile toista hakutermiä tai poista haku nähdäksesi kaikki mainokset uudelleen.',
    },
    buttons: {
      createListing: 'Uusi mainos',
    },
    item: {
      free: 'Ilmainen',
    },
    flashMessage: {
      deleteResourceSuccess: 'Mainos poistettu',
      deleteResourceFailure: 'Mainosta ei voitu poistaa',
    },
  },
  functionSettingsView: {
    title: 'Toiminnot',
    subtitle:
      'Sammuta tai ota käyttöön toimintoja, jotka asukkaiden tulee nähdä vasemmanpuoleisessa "Asukkaille" -valikossa.',
    table: {
      titles: {
        function: 'Toiminto',
        visible: 'Näytetään asukkaalle',
        visible_lgh: 'Näytetään vuokralaisille',
      },
    },
    form: {
      labels: {
        function: 'Toiminto',
        title: 'Otsikko',
        link: 'Linkki',
        content: 'Sisältö',
      },
      widgetTypeOptions: {
        link: 'Linkki',
        text: 'Teksti',
      },
    },
    buttons: {
      addFunction: 'Lisää toiminto',
    },
    modal: {
      createTitle: 'Luo toiminto',
      editTitle: 'Muokkaa toimintoa',
    },
    confirmationModal: {
      deleteTitle: 'Poista toiminto',
      deleteDescription: 'Haluatko varmasti poistaa toiminnon?',
    },
    flashMessage: {
      deleteWidgetSuccess: 'Toiminto poistettu',
      deleteWidgetFailure: 'Toimintoa ei voitu poistaa',
      updateWidgetSuccess: 'Toiminto päivitetty',
      updateWidgetFailure: 'Toimintoa ei voitu päivittää',
      createWidgetSuccess: 'Toiminto luotu',
      createWidgetFailure: 'Toimintoa ei voitu luoda',
    },
  },
  societyBlockedUsersView: {
    title: 'Estetyt käyttäjät',
    subtitle: `Kun käyttäjä on estetty, hänen käyttöoikeutensa on rajoitettu vain lukuoikeuteen. Tämä tarkoittaa, että hän näkee sisällön, mutta ei voi luoda uusia viestejä, kommentoida olemassa olevia viestejä tai käyttää chattia.

Tätä tulisi käyttää vain poikkeustapauksissa, ja päätöstä tulisi edeltää keskustelu käyttäjän kanssa.`,
    flashMessage: {
      userBlockRemoveSuccess: 'Esto poistettu',
      userBlockRemoveFailure: 'Estoa ei voitu poistaa',
      userBlockAddSuccess: 'Esto lisätty',
      userBlockAddFailure: 'Estoa ei voitu lisätä',
    },
    alert: {
      deleteBlockTitle: 'Poista esto',
      deleteBlockText: 'Haluatko varmasti poistaa eston?',
    },
    emptyState: {
      title: 'Ei estoja',
      subtitle: 'Ei estettyjä käyttäjiä tällä hetkellä',
    },
  },
  societySettingsView: {
    title: 'Asetukset',
    feedSettings: {
      title: 'Fiidin vaihtoehto',
      disablePostingTitle: 'Poista asukkaiden julkaisut ja kommentit käytöstä',
      disablePostingDisclaimerText:
        'Asukkaat eivät voi enää luoda tai kommentoida asukkaiden julkaisuja, mutta he voivat edelleen kommentoida hallituksen ja järjestelmänvalvojien julkaisuja. Tämä vaihtoehto tulee valita vain poikkeustapauksissa, koska se estää asukkaitasi luomasta arvokkaita ihmissuhteita.',
      marketplaceDisablePostingTitle:
        'Poista osto- ja myyntijulkaisut käytöstä',
    },
    chatSettings: {
      title: 'Chat-asetukset',
      disableOneOnOneTitle: 'Poista naapurichat käytöstä',
      disableInterestsTitle: 'Poista ryhmächat-ominaisuus käytöstä',
      disableAskBoardTitle: 'Poista kysymykset hallitukselta käytöstä',
      disableAskBoardTitle_lgh: 'Sulje kysymys isännöitsijältä',
      chatAskBoardDisabledResidentMessageTitle: 'Tiedote asukkaille',
      chatAskBoardDisabledResidentMessageTitle_lgh: 'Viesti asukkaille',
      chatAskBoardDisabledResidentMessagePlaceholder:
        'Ota yhteyttä hallitukseen sähköpostitse info@...',
      chatAskBoardDisabledResidentMessagePlaceholder_lgh:
        'Ole yhteydesä isännöitsijään sähköpostitse osoitteessa info@...',
    },
    updateSettingsSuccess: 'Päivitetty asetukset',
    contactListUserInformationSetting: 'Majoitusluettelon asetus',
    contactListUserInformation:
      'Näytä yhteystiedot (sähköposti ja puhelinnumero)',
  },
  supportView: {
    title: 'Tuki',
  },
  societyWebsiteView: {
    title: 'Verkkosivustomme',
    subTitle:
      'Tänne antamasi tiedot näkyvät julkisella yhdistyksesi verkkosivustolla. Olette yhdistyksenä vastuussa sisällöstä.',
    visitWebsite: 'Vieraile verkkosivustolla',
    tabBar: {
      generalInformation: 'Nimi ja kuvaus',
      images: 'Kuvat',
      documents: 'Asiakirja',
      questionsAndAnswers: 'Kysymyksiä ja vastauksia',
      contact: 'Yhteys',
    },
    subTitle_lgh:
      'Täällä antamasi tiedot näkyvät julkisella kiinteistön verkkosivustollasi. Te kiinteistönä olette vastuussa sisällöstä.',
  },
  societyWebsiteGeneralInformation: {
    form: {
      displayName: 'Nimi',
      description: 'Esittely',
    },
    flashMessage: {
      updateSuccess: 'Sivuston tiedot päivitettiin',
      updateFailure: 'Sivuston tietoja ei voitu päivittää',
    },
  },
  societyWebsiteContact: {
    form: {
      recipientId: 'Hallituksen jäsen',
      recipientId_lgh: 'Isännöitsijä',
      recipientLabel: 'Vastaanottaja',
      addMore: 'Lisää muita',
      copy: 'Kopio',
      copyTooltip:
        'Täällä lisäät sähköpostiosoitteet, joiden pitäisi saada kopio viesteistä, jotka on lähetetty verkkosivuston yhteydenottolomakkeella',
    },
    flashMessage: {
      updateSuccess: 'Yhteystieto päivitetty',
      updateFailure: 'Yhteystietoa ei voitu päivittää',
    },
    confirmationModal: {
      removeEmailTitle: 'Poista sähköpostiosoite',
      removeEmailText: 'Haluatko varmasti poistaa sähköpostiosoitteen?',
    },
  },
  societyWebsiteQuestionsAndAnswers: {
    flashMessage: {
      updateSuccess: 'Kysymyksiä ja vastauksia päivitettiin',
      updateFailure: 'Kysymyksiä ja vastauksia ei voitu päivittää',
    },
  },
  societyWebsiteDocuments: {
    addNewDocument: 'Lataa asiakirja',
    addNewFolder: 'Luo uusi kansio',
    emptyState: {
      title: 'Sinulla ei ole mitään luettavaa',
      emptyFolderSubtitle:
        'Tällä hetkellä ei ole julkaistuja asiakirjoja kansiossa {{folderName}}".',
      noDocumentsSubtitle:
        'Tällä hetkellä kansioita tai asiakirjoja ei ole julkaistu.',
    },
  },
  societyWebsite: {
    showOnWebsite: 'Näytä verkkosivulla',
  },
  supportContact: {
    infoText: 'Onko sinulla kysyttävää tai kommentoitavaa? Lähetä viesti!',
    form: {
      subject: 'Otsikko',
      subjectPlaceholder: 'Anna asiallesi lyhyt otsikko',
      message: 'Tiedote',
      messagePlaceholder: 'Kuvaile asiaa',
      send: 'Lähetä tiedote',
      whichPlatform: 'Mitä alustaa käytit, kun ongelma ilmeni?',
    },
  },
  bostadsratterna: {
    bostadsratternaBenefitsView: {
      title: 'Jäsenedut',
      benefitsTitle: 'Jäsenedut',
      benefitsText:
        'Jäsenenä saat meiltä erilaisia jäsenetuja (vaatii kirjautumisen).',
      insuranceTitle: 'Fastighetsförsäkring till förmånligt pris',
      insuranceText:
        'Vår fastighetsförsäkring, som är framtagen av Söderberg & Partners, har ett mer omfattande skydd än andra försäkringar på marknaden och gör att 9 av 10 föreningar får en bättre försäkring till ett lägre pris.',
      benefitsText_lgh:
        'Asuntoliiton jäsenenä saat käyttöösi laajan valikoiman jäsenetuja, jotka on huolellisesti suunniteltu helpottamaan ja vahvistamaan sekä isännöitsijän että asunto-osakekiinteistönne jäsenten työtä.',
      insuranceText_lgh:
        'Söderberg & Partnersin kehittämässä kiinteistövakuutuksessamme on kattavampi suoja kuin muilla markkinoilla olevilla vakuutuksilla, ja se tarkoittaa, että 9 kiinteistöä 10:stä saa paremman vakuutuksen halvemmalla.',
    },
    bostadsratternaSchoolView: {
      title: 'Asumisoikeuskoulu',
      coursesTitle: 'Kurssit',
      coursesText:
        'Koulutuksia kaikesta, mitä sinun tulee tietää hallitustyöstä.',
      seminarsTitle: 'Seminaarit',
      seminarsText: 'Lyhyemmät koulutuskurssit tehtävääsi yhdistyksessä.',
      webAndVideoCoursesTitle: 'Verkko- ja videokurssit',
      webAndVideoCoursesText:
        'Uudet interaktiiviset verkkokurssit, jotka tekevät oppimisesta hauskaa ja helppoa.',
      coursesText_lgh:
        'Asunto-oikeuskoulussa tarjoamme laajan valikoiman kursseja kaikille teille, jotka työskentelette kiinteistönne hallinnossa. Kaikki sisältyvät jäsenyyteen.',
      seminarsText_lgh: 'Lyhyempiä koulutuksia tehtävääsi kiinteistössä.',
    },
    bostadsratternaStatutesView: {
      title: 'Mallisäännöt',
      statutesTitle: 'Sääntömalli',
      statutesText:
        'Jäsenenä saat ilmaisen pääsyn mallisääntöihimme (vaatii kirjautumisen).',
      statutesText_lgh:
        'Jäsenenä teillä on vapaa pääsy sääntömallimme. Se voidaan ladata ja hyväksyä kokonaisuudessaan tai mukauttaa kiinteistönne tarpeisiin.',
    },
    bostadsratternaGuidanceView: {
      title: 'Hallituksen neuvonta',
      guidanceText: 'Ilmainen neuvonta arkisin klo 9.00-16.30',
    },
    bostadsratternaFormsView: {
      title: 'Lomakkeet',
      formsTitle: 'Käteviä lomakkeita',
      formsText:
        'Lomakkeet sopimuksiin, hakemuksiin ja muihin yhdistyksessä tarvittaviin asioihin (vaatii kirjautumisen).',
      formsText_lgh:
        'Asuntoliiton jäsenenä saatte mallimme ja lomakkeemme sopimuksia, hakemuksia ja muuta kiinteistössä tarvittavaa varten (sisäänkirjautuminen vaaditaan).',
    },
  },
  samfalligheterna: {
    samfalligheternaSchoolView: {
      title: 'Koulutukset',
      description:
        'Yhteisöyhdistykselle on olemassa paljon yksityiskohtaisia sääntöjä: jäsenmaksuista, miten päätökset tulee tehdä ja mitä yhteisö voi tehdä. Jos sinulla on uusia ihmisiä hallituksessa tai olet epävarma siitä, mikä sopii sinulle, on hyvä ajatus osallistua johonkin koulutuskursseistamme.',
      coursesTitle: 'Kurssit',
      coursesText:
        'Koulutuskursseillamme opit kaiken mitä tarvitset asumisoikeusyhdistyksen johtamiseen (vaatii kirjautumisen).',
      description_lgh:
        'Yhteisöyhdistykselle on olemassa monia yksityiskohtaisia sääntöjä: jäsenmaksuista, päätöksenteosta ja siitä, mitä yhteisö saa tehdä. Jos hallintoon on tullut uusia henkilöitä tai olette epävarmoja siitä, mikä on voimassa, on hyvä idea osallistua johonkin koulutuksiimme.',
      coursesText_lgh:
        'Koulutuksissamme opit kaiken, mitä sinun tarvitsee tietää yhteisökiinteistön hoitamiseksi (sisäänkirjautuminen vaaditaan).',
    },
    samfalligheternaBenefitsView: {
      title: 'Jäsenedut',
      description:
        'Tavoitteenamme on tehdä hallitustyöstä yhdistyksessäsi mahdollisimman sujuvaa ja nautinnollista. Kokomme vuoksi olemme saaneet hyvät alennukset ja edut tunnetuimmilta yrityksiltä. Jotta pääset vähän halvemmalla, kun ostat jotain yhdistykselle kuuluvaa.',
      benefitsTitle: 'Edut ja alennukset',
      benefitsText:
        'Ainutlaatuiset tarjoukset yhdistyksille, joilla on turvallisuussopimus (vaatii kirjautumisen).',
      description_lgh:
        'Tavoitteenamme on, että kiinteistönne hallinta olisi mahdollisimman sujuvaa ja iloista. Kokemme ansiosta olemme saaneet hyviä alennuksia ja etuja Ruotsin tunnetuimmilta yrityksiltä. Jotta pääsisitte hieman halvemmalla, kun ostatte jotain kiinteistöön liittyvää.',
      benefitsText_lgh:
        'Yksinomaisia tarjouksia kiinteistöille, joilla on turvasopimus (sisäänkirjautuminen vaaditaan).',
    },
    samfalligheternaGuidanceView: {
      title: 'Hallituksen neuvonta',
      guidanceDescription:
        'Saat ilmaisia neuvoja lakimiehiltämme, maanmittareiltamme, rakennusinsinööreiltämme, geoteknikoilta, energia-, putki- ja puutarhaneuvojiltamme.',
      guidanceText:
        'Ilmainen neuvonta 08:30-16:30 ma-torstai, 08:30-14:00 perjantai',
    },
  },
  managementPartnerContactForm: {
    writeQuestionTitle: 'Kirjoita kysymyksesi',
    writeQuestionPlaceholder: 'Tiedote',
    sendQuestionTitle: 'Lähetä kysymys',
    shareInformationTitle: 'Jaa tietoja',
    shareInformationTooltipBostadsratterna:
      'Sinun ja yhdistyksesi yhteystiedot jaetaan asumisoikeusyhdistysten kanssa',
    shareInformationTooltipSamfalligheterna:
      'Sinun ja järjestösi yhteystiedot jaetaan yhtymille',
    helperText: 'Tavoitteemme on vastata 24 tunnin kuluessa.',
    messageSendFailure: 'Tiedotetta ei voitu lähettää',
    messageSendSuccess: 'Tiedote on lähetetty',
    shareInformationTooltipBostadsratterna_lgh:
      'Yhteystietosi ja kiinteistösi jaetaan asuntoliittoon',
    shareInformationTooltipSamfalligheterna_lgh:
      'Yhteystietosi ja kiinteistösi jaetaan yhteisöille',
  },
  scheduledPosts: {
    bannerTitleSingle: '1 ajastettu julkaisu',
    bannerTitlePlural: '{{total}} ajastettua julkaisua',
    nextPublish: 'Seuraava julkaistaan {{date}}',
    publishInfo: 'klo {{time}} · {{relative}}',
    edit: 'Muokkaa',
    form: {
      label: 'Ajasta julkaisu',
      helpText:
        'Julkaisu näkyy fiidissä valitusta ajankohdasta alkaen. Jätä tyhjäksi julkaistaksesi heti.',
      scheduleAction: 'Ajasta',
    },
    deleteTitle: 'Poista ajastettu julkaisu',
    deleteText: 'Julkaisua ei ole vielä julkaistu. Haluatko poistaa sen?',
    flashMessage: {
      scheduleSuccess: 'Julkaisu on ajastettu',
      rescheduleSuccess: 'Julkaisuaika on päivitetty',
      publishNowSuccess: 'Julkaisu julkaistaan nyt',
    },
  },
  feedView: {
    title: 'Fiidi',
    newPost: 'Kirjoita julkaisu...',
    modalTitle: 'Uusi julkaisu',
    create: 'Luo',
    filterFeed: {
      title: 'Suodata julkaisut',
      modalTitle: 'Suodata',
      subtitle: 'Valitse, mitä haluat nähdä fiidissäsi',
      societyFilterTitle: 'Yhdistys',
      societyFilterTitle_lgh: 'Kiinteistöt',
      primaryButtonTitle: 'Vahvista',
      postsFilterTitle: 'Julkaisu',
      postsFilterAllOptionValue: 'Näytä kaikki',
      postsFilterBoardOptionValue: 'Hallituksen julkaisu',
      postsFilterBoardOptionValue_lgh: 'Julkaisut isännöitsijältä',
      postsFilterNeighboursOptionValue: 'Julkaisut naapureilta',
      postsFilterImportantOptionValue: 'Tärkeitä tiedotteita',
      societiesFilterTitle: 'Suodata yhdistyksiä',
      societiesFilterTitle_lgh: 'Suodata kiinteistöt',
      societiesFilterAllOptionValue: 'Näytä kaikki',
    },
    emptyFilter: {
      title: 'Julkaisuja ei löytynyt',
      subtitle: 'Vaihda suodattimia tai luo uusi julkaisu',
    },
    emptyState: {
      noSociety: {
        title: 'Ei ole yhdistyksen jäsen',
        subtitle: 'Mitä haluat tehdä?',
        buttonTitle: 'Liity olemassa olevaan yhdistykseen',
        createSocietyButton: 'Luo uusi yhteiskunta',
        title_lgh: 'Et ole kiinteistön jäsen',
        buttonTitle_lgh: 'Liity olemassa olevaan kiinteistöön',
        createSocietyButton_lgh: 'Luo uusi kiinteistö',
      },
      pendingRequest: {
        title: 'Odotetaan vahvistusta hallitukselta',
        subtitle:
          'Täällä voit tykätä, kommentoida ja luoda julkaisuja sekä saada tärkeitä tietoja hallitukselta.',
        buttonTitle: 'Etsi yhdistys',
        buttonTitle_lgh: 'Etsi kiinteistö',
      },
      emptyFeed: {
        title: 'Ei julkaisuja fiidissä',
        subtitle:
          'Täällä voit tykätä, kommentoida ja luoda julkaisuja sekä saada tärkeitä tietoja hallitukselta.',
        buttonTitle: 'Luo julkaisu',
      },
    },
    formatText: {
      title: 'Kirjoita seuraava tekstin muotoilemiseksi',
      label: 'Tekstin muotoilu',
      bold: 'Lihavoitu',
      italic: 'Kursiivi',
      header: 'Otsikko',
      bulletPoints: 'Listaus',
      list: 'Luettelo',
      horizontalLine: 'Vaakasuora viiva',
    },
  },
  userView: {
    dateTitle: 'Asunnonomistaja vuodesta',
    dateTitle_lgh: 'Asukas vuodesta',
    interestsTitle: 'Kiinnostuksen kohteet',
    educationTitle: 'Koulutus',
    occupationTitle: 'Työ',
    presentationTitle: 'Tietoja henkilöstä {{name} }',
  },
  postView: {
    errorView: {
      removed: {
        title: 'Julkaisu on poistettu',
        subtitle:
          'Julkaisu on poistettu. Napsauta yllä olevaa painiketta palataksesi fiidiin.',
      },
    },
    print: {
      published: 'Julkaistu {{date}}',
      content: 'Sisältö',
      nothingSelected: 'Valitse vähintään yksi tulostettava osa.',
      commentsLoading: 'Kommentteja ladataan…',
      commentsFailed: 'Kommentteja ei voitu ladata.',
      sections: {
        header: 'Nimi ja logo',
        important: 'Tärkeä tiedote',
        author: 'Kirjoittaja',
        date: 'Päivämäärä',
        text: 'Teksti',
        media: 'Kuvat',
        events: 'Tapahtumat',
        polls: 'Äänestykset',
        attachments: 'Edut, ilmoitukset, yhteystiedot ja tilat',
        comments: 'Kommentit',
      },
      video: 'Video – katso julkaisu Boappassa',
      cancelled: 'Peruttu',
    },
  },
  post: {
    important: 'Tärkeä tiedote',
    importantMobile: 'Tärkeää',
    pinned: 'Kiinnitetty julkaisu',
    showMoreComments: 'Näytä lisää kommentteja',
    showEarlierComments: 'Näytä aiemmat kommentit',
    commentUnavailable: 'Kommenttia ei enää ole.',
    showDiscussion: 'Näytä kommentit',
    peopleEmpty: 'Ei ketään näytettäväksi.',
    commentInputPlaceholder: 'Kirjoita kommentti...',
    editedPrefix: 'Muokattu',
    event: {
      prefix: 'Tapahtuma',
      allDay: 'Koko päivä',
      goToEvent: 'Siirry tapahtumaan',
      addToCalendar: 'Lisää kalenteriin',
    },
    alert: {
      postDeleteTitle: 'Poista julkaisu',
      postDeleteText:
        'Haluatko varmasti poistaa julkaisun? Tätä toimintoa ei voi kumota, ja julkaisu katoaa kaikilta yhteyden käyttäjiltä.',
      commentDeleteTitle: 'Poista kommentti',
      commentDeleteText: 'Haluatko varmasti poistaa kommentin?',
      postDeleteText_lgh:
        'Haluatko varmasti poistaa julkaisun? Tätä toimintoa ei voi perua ja julkaisu katoaa kaikilta kiinteistön käyttäjiltä.',
    },
    flashMessage: {
      deletePostSuccess: 'Julkaisu poistettu',
      deletePostFailure: 'Julkaisua ei voitu poistaa',
      pinLimitReached: 'Voit kiinnittää vain {{ max }} julkaisua',
      deleteCommentSuccess: 'Kommentti poistettu',
      deleteCommentFailure: 'Kommenttia ei voitu poistaa',
    },
    newMarketPlaceItemText: 'Uusi osto- ja myynti-ilmoitus',
    newFacilityText: 'Uusi tila on lisätty',
    newContactText: 'Uusi yhteys on lisätty',
    newLocalOfferText: 'Uusi etu on lisätty',
    tooltip: {
      visibility: {
        base: 'Julkaisu näytetään',
        admins: 'ylläpitäjät',
        board: 'hallitus',
        board_lgh: 'isännöitsijä',
        groups: 'ryhmät',
      },
    },
    seenBy: 'Lukenut',
  },
  previewPost: {
    title: 'Esikatsele julkaisua',
    preview: 'Esikatselu',
  },
  pendingRequest: {
    title: 'Hienoa!',
    subtitle: 'Pääset yhdistykseen heti, kun hallitus on hyväksynyt tiedot.',
    titleAdvice: 'Vinkki: Sovellukseen voi tutustua jo etukäteen.',
    whatHappensNextTitle: 'Mitä tapahtuu seuraavaksi?',
    notificationText:
      'Kun sinut on hyväksytty, saat ilmoituksen sekä verkkosovelluksessa että sähköpostin. \nNoudata sähköpostissa olevia ohjeita tai avaa verkkosovellus ja käynnistä Boappa!',
    assignmentText: 'Jos sinua ei ole hyväksytty - ota yhteyttä hallitukseen.',
    checkOutTheApp: 'Tutustu verkkosovellukseen!',
    subtitle_lgh:
      'Saat pääsyn kiinteistöön heti kun isännöitsijä hyväksyy tiedot.',
  },
  requestJoinSocietyForm: {
    sendRequest: 'Lähetä tiedustelu',
    title: 'Hae yhdistyksen jäsenyyttä',
    title_samf: 'Hae yhdistyksen jäsenyyttä',
    title_lgh: 'Hae jäsenyyttä kiinteistöön',
    flashMessage: {
      sendRequestSuccess: 'Tiedustelu lähetetään',
      sendRequestFailure: 'Tiedustelua ei voitu lähettää',
    },
    tooltip: {
      unit: 'Asuntonumerosi 4 ensimmäistä numeroa antaa Maanmittauslaitos\n\nJos numerot ovat suluissa ( ), yhdistyksesi on antanut numeron',
      role: 'Jäsen: Sinä, joka omistat asumisoikeuden ja olet siten yhdistyksen jäsen \n\nAsukkaat: Jos olet esimerkiksi huoneiston omistajan avopuoliso, puoliso, ystävä, asukas tai lapsi. \n\nVuokralainen: Vuokraat asumisoikeutta. \n\nOmainen: Asunnonomistajaa edustava henkilö.',
      unit_lgh:
        'Huoneistonumerosi 4 ensimmäistä numeroa on antanut maanmittauslaitos \n\nJos numerot ovat sulkeissa ( ), kiinteistösi on antanut numeron',
      role_lgh:
        'Jäsen: Sinä, joka omistat asunto-oikeuden ja olet siten kiinteistön jäsen \n\nAsukas: Jos olet esimerkiksi avopuoliso, kumppani, ystävä, asukas, huoneiston omistajan lapsi. \n\nVuokralainen: Vuokraat asunto-oikeutta. \n\nSukulainen: Henkilö, joka edustaa jäsentä.',
    },
  },
  inactiveSociety: {
    title: 'Yhdistystä ei ole aktivoitu',
    subtitle:
      'Yhdistyksen aktivoimiseksi sinun tulee olla hallituksen jäsen. Voit liittyä yhdistyksen jäseneksi testaamaan, mutta et pääse käyttämään kaikkia sovelluksen toimintoja.',
    tabs: {
      board: 'Hallituksen jäsen',
      member: 'Jäsen',
    },
    board: {
      boardTitle: 'Vaihtoehto 2: Liity hallituksen jäseneksi',
      boardSubtitle:
        'Jos olet hallituksessa, mutta et halua ryhtyä ylläpitäjäksi, voit halutessasi liittyä yhdistykseen. Et voi käyttää kaikkia sovelluksen toimintoja.',
      adminTitle: 'Vaihtoehto 1: Liity ylläpitäjänä',
      adminSubtitle:
        'Aktivoi yhdistyksesi ja hanki sovelluksen kaikki toiminnot. Tämän jälkeen sinulle määrätään yhdistyksesi pääkäyttäjän rooli ja voit nimittää lisää ylläpitäjiä.',
      boardSubtitle_lgh:
        'Jos olet isännöitsijä, mutta et halua tulla järjestelmänvalvojaksi, voit valita vain liittyä kiinteistöön. Sinulla ei ole pääsyä kaikkiin sovelluksen toimintoihin.',
      adminSubtitle_lgh:
        'Aktivoi kiinteistösi ja saat täyden toiminnallisuuden sovelluksessa. Sinulle myönnetään kiinteistösi pääkäyttäjän rooli ja voit sen jälkeen nimetä lisää järjestelmänvalvojia.',
    },
    member: {
      title: 'Liity yhdistykseen',
      subtitle:
        'Yhdistystä ei ole vielä aktivoitu, mutta siihen liittyminen ei ole ongelma riippumatta siitä, oletko asunnonomistaja vai hallituksen jäsen.',
      title_lgh: 'Liity kiinteistöön',
      subtitle_lgh:
        'Kiinteistöä ei ole vielä aktivoitu, mutta voit vapaasti liittyä siihen riippumatta siitä, oletko asukas vai isännöitsijä.',
    },
    flashMessage: {
      joinSocietySuccess: 'Liittyi yhdistykseen',
      joinSocietyFailure: 'Ei voinut liittyä yhdistykseen',
      activateSocietyFailure: 'Yhdistystä ei voitu aktivoida',
      activateSocietySuccess: 'Yhdistys aktivoitu',
      joinSocietySuccess_lgh: 'Liittyi kiinteistöön',
      joinSocietyFailure_lgh: 'Ei voinut liittyä kiinteistöön',
      activateSocietyFailure_lgh: 'Kiinteistöä ei voitu aktivoida',
      activateSocietySuccess_lgh: 'Kiinteistö aktivoitiin',
    },
    title_lgh: 'Kiinteistöä ei ole aktivoitu',
    subtitle_lgh:
      'Kiinteistön aktivoimiseksi sinun tulee olla isännöitsijä. Voit liittyä kiinteistöön jäsenenä kokeillaksesi, mutta sinulla ei ole pääsyä kaikkiin sovelluksen toimintoihin.',
  },
  findSociety: {
    labels: {
      newSociety: 'Uusi yhdistys',
      userMemberOfSociety: 'Kirjautunut sisään',
      hasPendingRequest: 'Tiedustelu lähetetty',
      search: 'Hae nimellä, osoitteella tai yritystunnuksella',
      brfDeveloper: 'Kiinteistökehittäjä?',
      cannotFindSociety:
        'Etkö löydä yhdistystäsi tai haluatko lisätä uuden kaupunginosan?',
      newSociety_lgh: 'Uusi kiinteistö',
      cannotFindSociety_lgh: 'Etkö löydä kiinteistöäsi?',
    },
  },
  createSocietyView: {
    title: 'Luo uusi yhdistys',
    tabs: {
      housingCooperative: 'Asumisoikeusyhdistykseni hallitus',
      homeownersAssociation: 'Yhtymäni hallitus',
      realEstateDeveloper: 'Kiinteistökehittäjä',
    },
    title_lgh: 'Luo uusi kiinteistö',
  },
  createSocietyForm: {
    createSocietyTitle: 'Luo yhdistys',
    realEstateDeveloperTitle: 'Luo uusi yhdistys',
    neighbourhoodTitle: 'Naapurusto',
    samfTitle: 'Luo yhtymä',
    brfTitle: 'Luo oma asuntoyhdistys',
    societyOrProjectTitle: 'Yhdistys/projekti',
    societyNameTooltipTitle: 'Vakiolyhenteet',
    societyNameTooltipText:
      'Anläggningssamfällighet = As\nBostadsförening = Bf\nBostadsrättsförening = Brf\nEkonomisk förening = Ek för\nGemensamhetsanläggning = Ga\n_samfällighetsförening = Samf\nUtan personligt ansvar = Upa\nVägsamfällighet = Vägsam\nVägförening = Vägf',
    addressStreet: 'Osoite',
    headers: {
      realEstateDeveloper: 'Kiinteistökehittäjä',
      society: 'Yhdistys/projekti',
      societyAlreadyExists: 'Yhdistyksesi on jo Boappassa',
      society_lgh: 'Kiinteistö/projekti',
    },
    labels: {
      numberOfBillingUnits: 'Huoneistojen lukumäärä',
      numberOfBillingUnits_samf: 'Kiinteistöjen lukumäärä',
      societyName: 'Yhdistyksen nimi',
    },
    errors: {
      societyAlreadyActivated: 'Yhdistys on jo aktivoitu',
    },
    modal: {
      title: 'Yhdistyksesi on jo Boappassa',
      organisationNumberShort: 'Y-tunnus',
      alreadyMemberOfSociety: 'Olet jo tämän yhdistyksen jäsen.',
      societyExistsButInactive:
        'Yhdistys on jo olemassa, mutta se ei ole aktiivinen',
      title_lgh: 'Kiinteistösi on jo Boappassa',
    },
    flashMessage: {
      createSocietySuccess: 'Yhdistys on perustettu',
      createSocietyFailure: 'Yhdistystä ei voitu luoda',
    },
  },
  findSocietyConfirmActivationForm: {
    roleTitle: 'Mikä on roolisi hallituksessa?',
    inviteBoardMembersTitle:
      'Kutsu hallituksen kollegojasi testaamaan Boappaa yhdessä (valinnainen)',
    numberOfApartmentsTitle: 'Huoneistojen kokonaismäärä',
    numberOfApartmentsTitle_samf: 'Kiinteistöjen kokonaismäärä',
    numberOfApartmentsDescription:
      'Ilmoita yhdistykseen kuuluvien huoneistojen kokonaismäärä. Sisältää myös liike- ja vuokrahuoneistot.',
    numberOfApartmentsDescription_samf:
      'Ilmoita yhdistykseen kuuluvien kiinteistöjen kokonaismäärä. Sisältää myös liike- ja vuokrakiinteistöt.',
    enterEmail: 'Anna sähköpostiosoite',
    flashMessage: {
      invitesSentSuccess: 'Kutsut lähetetty',
    },
  },
  findSocietyConfirmActivationView: {
    title: 'Pian valmista!',
    subtitle:
      'Tarvitsemme sinulta lisätietoja, ennen kuin voit aloittaa Boappan käytön.',
  },
  activatedSocietyConfirmationView: {
    title: 'Yhdistys on aktivoitu!',
    subtitle:
      'Olet nyt rekisteröitynyt pääkäyttäjäksi ja voit kutsua hallituksen jäseniä testaamaan Boappaa.',
    buttonTitle: 'Aloita Boappan käyttö!',
    title_lgh: 'Kiinteistö on aktivoitu!',
  },
  newSocietyView: {
    title: 'Uusi yhdistys',
    title_lgh: 'Uusi kiinteistö',
  },
  findSocietyView: {
    title: 'Lisää uusi yhdistys',
    header:
      'Näin helposti voit myös sinä päästä alkuun ja käyttää Boappa omassa taloyhtiössäsi.',
    description:
      'Boappa avulla sinä ja naapurisi voitte helposti saada tietoa siitä, mitä taloyhtiössä tapahtuu, ja nopeasti ottaa yhteyttä sekä hallitukseen että naapureihin. Boappa on saatavilla sekä sovelluksena että verkkopalveluna, ja sen käyttöönotto on helppoa.',
    description2:
      'Jos olet saanut kutsun sähköpostitse taloyhtiöltä liittyäksesi, sinun tarvitsee vain vahvistaa kutsu kirjautumisen jälkeen Boappaan. Muussa tapauksessa voit hakea mukaan taloyhtiöön alla olevan ohjeen mukaisesti.',
    description3: 'Aloita etsimällä taloyhtiösi:',
    title_lgh: 'Etsi kiinteistösi',
    header_lgh:
      'Näin helposti myös sinä voit aloittaa ja käyttää Boappaa kiinteistössäsi.',
    description_lgh:
      'Boappan avulla sinä ja naapurisi voitte helposti saada tietoa siitä, mitä kiinteistössä tapahtuu, ja nopeasti ottaa yhteyttä sekä isännöitsijään että naapureihin. Boappa on saatavilla sekä sovelluksena että verkkopalveluna, ja sen käyttöönotto on helppoa.',
    description2_lgh:
      'Jos olet saanut kutsun sähköpostitse kiinteistöltä liittyäksesi, sinun tarvitsee vain vahvistaa kutsu kirjautumisen jälkeen Boappaan. Muussa tapauksessa voit hakea liittyä kiinteistöön alla olevan ohjeen mukaisesti.',
    description3_lgh: 'Aloita etsimällä kiinteistö:',
  },
  findFriendsView: {
    title: 'Tutustu naapureihin',
    description:
      'Etsi juoksukaveri naapurista tai hanki seuraa vaunukävelylle kauempaa kadun varrelta.',
    extra:
      'Lisää kiinnostuksen kohteesi profiiliisi ja katso, ketkä naapurit jakavat samat kiinnostuksen kohteet.',
    updateYourProfile: 'Päivitä profiilisi',
    errorView: {
      noMatches: {
        title: 'Ei osumia',
        subtitle:
          'Päivitä profiilisi ja selvitä, kenellä on samat kiinnostuksen kohteet kuin sinulla',
      },
    },
  },
  questionsAndAnswersView: {
    title: 'Kysymyksiä ja vastauksia',
    emptyState: {
      title: 'Ei kysymyksiä ja vastauksia',
      subtitle: 'Hallitus ei ole vielä lähettänyt kysymyksiä ja vastauksia.',
      subtitle_lgh:
        'Isännöitsijä ei ole vielä lähettänyt kysymyksiä ja vastauksia.',
      noQuestionsAndAnswersText:
        'Tässä osiossa ei ole kysymyksiä eikä vastauksia.',
    },
  },
  societyCalendarListView: {
    title: 'Kalenteri',
    buttons: {
      create: 'Uusi kalenteritapahtuma',
    },
    activeTabBar: {
      previousTitle: 'Aiempi',
      upcomingTitle: 'Tuleva',
    },
    noCalendarEvents: {
      title: 'Ota rennosti, kalenterissa ei ole varauksia.',
      subtitle: 'Tällä hetkellä ei ole näytettäviä kalenteritapahtumia.',
    },
  },
  eventDetailView: {
    errors: {
      notFound: {
        title: 'Kalenteritapahtumaa ei löytynyt',
        subtitle: 'Yritit käyttää kalenteritapahtumaa, jota ei ole olemassa.',
      },
    },
    tabBar: {
      information: 'Tiedot',
      attendance: 'Osallistujaluettelo',
    },
    headers: {
      date: 'Päivämäärä',
      attendants: 'Osallistuja',
    },
    attendance: {
      titles: {
        attending: 'Tulossa',
        notAttending: 'Ei voi tulla',
        noReply: 'Ei vastausta',
      },
      list: 'Tulossa lista',
    },
    buttons: {
      seeAllAttendants: 'Näytä kaikki osallistujat',
    },
  },
  createUpdateEvent: {
    addToCalendar: 'Lisää kalenteriin',
    modal: {
      createTitle: 'Luo tapahtuma',
      editTitle: 'Muokkaa tapahtumaa',
    },
    confirmationModal: {
      deleteTitle: 'Poista tapahtuma',
      deleteDescription: 'Haluatko varmasti poistaa tapahtuman?',
    },
    form: {
      labels: {
        title: 'Aktiviteetti',
        location: 'Paikka',
        isAllDay: 'Koko päivä',
        startDate: 'Aloitusaika',
        endDate: 'Päättymisaika',
        startDay: 'Alkupäivämäärä',
        endDay: 'Päättymispäivä',
        description: 'Kuvaus',
        attendanceEnabled: 'Osallistujaluettelo',
        allowComments: 'Salli kommentit',
      },
    },
    flashMessage: {
      updateEventSuccess: 'Tapahtuma päivitetty',
      updateEventFailure: 'Tapahtumaa ei voitu päivittää',
      createEventSuccess: 'Tapahtuma luotu',
      createEventFailure: 'Tapahtumaa ei voitu luoda',
      deleteEventSuccess: 'Tapahtuma poistettu',
      deleteEventFailure: 'Tapahtumaa ei voitu poistaa',
    },
  },
  facilitiesView: {
    title: 'Varaukset ja palvelut',
    tabBar: {
      newBooking: 'Uusi varaus',
      myBookings: 'Omat varaukseni',
    },
    emptyState: {
      noFacilitiesTitle: 'Ei ole mitään varattavaa',
      noFacilitiesSubtitle:
        'Hallitus ei ole lisännyt yhteisiä tiloja digitaaliseen varaukseen. Jos sinulla on ehdotuksia varattavissa olevista tiloista tai kohteista, kerro siitä hallitukselle luomalla tehtävän kohdassa "Tehtävä".',
      noFacilitiesSubtitle_lgh:
        'Isännöitsijä ei ole lisännyt yhteisiä tiloja digitaaliseen varaukseen. Jos sinulla on ehdotuksia varattavissa olevista tiloista tai kohteista, kerro siitä isännöitsijälle luomalla tehtävän kohdassa "Tehtävä".',
      noBookingsTitle: 'Sinulla ei ole varauksia',
      noBookingsSubtitle:
        'Siirry kohtaan "Uusi varaus" ja valitse tila, jonka haluat varata. Varauksesi näkyy sitten täällä.',
    },
    buttons: {
      create: 'Luo tila',
    },
  },
  createUpdateFacility: {
    editFacilityTitle: 'Muokkaa tilaa',
    createFacilityTitle: 'Luo tila',
    form: {
      labels: {
        booking: 'Varattavissa',
        coverPhoto: 'Kansikuva',
        name: 'Otsikko',
        description: 'Kuvaus',
        bookingGranularity: 'Varausväli',
        rules: 'Varaussäännöt',
        bookableFrom: 'Varattavissa alkaen',
        bookableTo: 'Varattavissa asti',
        bookableUntilFurtherNotice: 'Toistaiseksi',
        visibility: 'Näkyvyys',
        bookingMessage: 'Varaustiedote',
        notificationEmails: 'Ilmoitus varauksen ja peruutuksen yhteydessä',
        blockedDates: 'Estetty päivämäärä',
        weeklySchedule: 'Viikkoaikataulu',
      },
      helperText: {
        coverPhoto: 'Suositeltu vähimmäiskuvakoko: 1280x800 pikseliä',
      },
      headers: {
        general: 'Yleistä',
        details: 'Varaustiedot',
        notificationSettings: 'Ilmoitusasetukset',
        recipient: 'Vastaanottaja',
        cc: 'Kopio',
        day: 'Päivä',
        startTime: 'Alku',
        endTime: 'Loppu',
        active: 'Aktiivinen',
      },
      warnings: {
        bookingGranularity: {
          cantEdit:
            'Et voi muuttaa aikataulua, kun tilassa on aktiivisia varauksia.',
        },
      },
      options: {
        visibility: {
          all: 'Kaikki',
          adminOnly: 'Vain ylläpitäjät',
        },
        bookingGranularity: {
          oneHour: 'Yksi tunti',
          twoHours: 'Kaksi tuntia',
          threeHours: 'Kolme tuntia',
          fourHours: 'Neljä tuntia',
          fiveHours: 'Viisi tuntia',
          fullDay: 'Koko päivä',
          eightHours: 'Kahdeksan tuntia',
          sevenHours: 'Seitsemän tuntia',
          sixHours: 'Kuusi tuntia',
        },
        rules: {
          oneActive: 'Aktiivinen varaus',
          twoActive: 'Kaksi aktiivista varausta',
          threeActive: 'Kolme aktiivista varausta',
          fourActive: 'Neljä aktiivista varausta',
          fiveActive: 'Viisi aktiivista varausta',
          unlimited: 'Rajoittamaton määrä varauksia',
        },
      },
    },
    flashMessage: {
      updateFacilityFailure: 'Tilaa ei voitu päivittää',
      updateFacilitySuccess: 'Tila on päivitetty',
      createFacilityFailure: 'Tilaa ei voitu luoda',
      createFacilitySuccess: 'Tila on luotu',
      deleteFacilitySuccess: 'Tila poistettu',
      deleteFacilityFailure: 'Tilaa ei voitu poistaa',
    },
    confirmationModal: {
      deleteTitle: 'Poista tila',
      deleteDescription: 'Haluatko varmasti poistaa tilan?',
    },
    weeklyScheduleDescription:
      'Paina aikataulun numeroita muuttaaksesi alkamis- tai lopetusaikaa. Voit määrittää koko päivän varauksen asettamalla ajat 00:00 - 00:00.',
  },
  facilityView: {
    tabBar: {
      calendar: 'Kalenteri',
      information: 'Tiedot',
      bookings: 'Varaukset',
    },
    calendar: {
      sections: {
        chooseUnit: {
          title: 'Minkä huoneiston haluat varata?',
          title_samf: 'Minkä kiinteistön haluat varata?',
        },
        chooseDate: {
          title: 'Valitse päivämäärä',
        },
        chooseSlot: {
          title: 'Valitse aika',
        },
        bookingMessage: {
          title: 'Varaustiedote',
        },
        yourBooking: {
          title: 'Omat varaukseni',
        },
      },
      fullDay: 'Koko päivä',
      booked: 'Varattu',
      alert: {
        unitMaxNumberBookings:
          'Olet saavuttanut aktiivisten varausten enimmäismäärän tilalle.',
        noTimeSlots: 'Valitulle päivälle ei ole vapaita aikoja.',
        noUnit: 'Varauksen tekemiseksi sinulle on määrättävä huoneisto.',
        noUnit_samf: 'Varauksen tekemiseksi sinulle on määrättävä kiinteistö.',
        bookingDisabledText: 'Tiloja ei voi varata.',
      },
      flashMessage: {
        createBookingSuccess: 'Varattu',
        createBookingFailure: 'Varausta ei voitu luoda',
      },
    },
    information: {
      sections: {
        description: {
          title: 'Kuvaus',
          noDescriptionText: 'Tilalla ei ole kuvausta.',
        },
      },
    },
    bookings: {
      buttons: {
        previousMonth: 'Edellinen kuukausi',
        nextMonth: 'Ensi kuussa',
        deleteBooking: 'Peruuta aika',
      },
      errorView: {
        noBookings: {
          title: 'Ei varauksia',
          subtitle: 'Siirry "Kalenteri"-välilehdelle varataksesi tämän tilan.',
        },
      },
      alert: {
        deleteTitle: 'Peruuta aika',
        deleteDescription: 'Haluatko varmasti poistaa varauksen?',
        deleteOtherUserBookingDescription:
          'Haluatko varmasti poistaa varauksen, jonka on tehnyt {{ name }}?',
        deleteBookingButtonLabel: 'Peruuta',
      },
      flashMessage: {
        deleteBookingFailure:
          'Aikaa ei voitu peruuttaa. Ajankohta voi olla mennyt',
        deleteBookingSuccess: 'Peruutettu',
      },
    },
  },
  houseRulesView: {
    title: 'Viihtymissäännöt',
    emptyState: {
      title: 'Ei viihtymissääntöjä',
      subtitle: 'Kun lautakunta luo uusia sääntöjä, ne näkyvät täällä.',
      subtitle_lgh: 'Kun isännöitsijä luo uusia sääntöjä, ne näkyvät täällä.',
    },
  },
  societyInviteModal: {
    title: 'Löysimme kotisi!',
    buttons: {
      accept: 'Kyllä, pitää paikkansa!',
      deny: 'Hylkää kutsu',
    },
    flashMessage: {
      acceptPreApprovedSuccess: 'Yhdistys on lisätty',
      acceptPreApprovedFailure: 'Yhdistystä ei voitu lisätä',
      denyPreApprovedSuccess: 'Kutsu on hylätty',
      denyPreApprovedFailure: 'Kutsua ei voitu hylätä',
    },
  },
  ticket: {
    status: {
      open: 'Open',
      closed: 'Closed',
    },
    closedBanner: {
      title: 'This ticket is closed',
      subtitle:
        'You can still view the conversation, but no new messages can be sent.',
    },
    variant: {
      report: 'Issue',
      question: 'Question',
    },
    error: {
      notFound: 'Could not find ticket',
    },
  },
  ticketListView: {
    empty: {
      title: 'Ei tehtäviä',
      subtitle_open: 'Kun uusi tehtävä tulee, se näkyy täällä',
      subtitle_all: 'Täällä näet sekä avoimet että suljetut tehtävät',
    },
    sender: {
      me: 'You',
      board: 'Board',
    },
    message: {
      sentImage: 'sent an image',
      sentFile: 'sent a file',
    },
  },
  ticketNav: {
    my: 'My',
    create: 'Create new ticket',
    open: 'Open',
    all: 'All',
    closed: 'Closed tickets',
  },
  ticketListViewBoard: {
    empty: {
      title: 'Ei tehtäviä',
      subtitle_my: 'Kun sinulle määritetään tehtävä, se näkyy täällä',
      subtitle_open: 'Kun uusi tehtävä tulee, se näkyy täällä',
      subtitle_all: 'Täällä näet sekä avoimet että suljetut tehtävät',
    },
    sender: {
      me: 'You',
      deletedUser: 'Deleted user',
    },
    message: {
      sentImage: 'sent an image',
      sentFile: 'sent a file',
    },
  },
  ticketBoardView: {
    title: 'Ticket management',
    disabled: {
      title: 'Tickets - Board questions is not enabled for members',
      title_report: 'Tickets - Report issue is not enabled for members',
      subtitle: 'Enable it under features',
    },
  },
  ticketView: {
    title: 'Tehtävä',
    form: {
      title: 'New ticket',
      tabs: {
        question: 'Kysymys hallitukselle',
        report: 'Vikailmoitus',
      },
      labels: {
        customer: 'Recipient',
        title: 'Otsikko',
        description: 'Kuvaus',
        images: 'Kuvat',
        documents: 'Asiakirjat',
        space: 'Missä vika ilmeni?',
      },
      space: {
        apartment: 'Asunto',
        building: 'Rakennus',
        surroundings: 'Ympäristö',
        commonAreas: 'Yhteiset tilat',
        other: 'Muu',
      },
    },
    attachments: {
      images: 'Kuvat',
      documents: 'Asiakirjat',
    },
    flashMessage: {
      createTicketSuccess: 'Tehtävä luotu',
      createTicketFailure: 'Tehtävää ei voitu luoda',
    },
  },
  ticketDetailView: {
    title: 'Tehtävä',
    links: {
      chat: 'Chat',
      documents: 'Documents',
      images: 'Images',
    },
  },
  ticketDetailViewBoard: {
    title: 'Tehtävä',
    links: {
      chat: 'Chat',
      documents: 'Documents',
      images: 'Images',
      manage: 'Manage',
    },
  },
  ticketSidebar: {
    images: 'Images',
    documents: 'Documents',
    imagesTitle: 'Images',
    documentsTitle: 'Documents',
    emptyImagesTitle: 'No ticket images',
    emptyDocumentsTitle: 'No ticket documents',
    titleLabel: 'Title',
    descriptionLabel: 'Description',
    createdAtLabel: 'Created',
    variantLabel: 'Ticket type',
    spaceLabel: 'Where did the issue occur?',
  },
  ticketBoardSidebar: {
    images: 'Images',
    documents: 'Documents',
    imagesTitle: 'Images',
    documentsTitle: 'Documents',
    emptyImagesTitle: 'No ticket images',
    emptyDocumentsTitle: 'No ticket documents',
    titleLabel: 'Title',
    customerLabel: 'Resident',
    descriptionLabel: 'Description',
    createdByLabel: 'Created by',
    createdAtLabel: 'Created',
    assignLabel: 'Assign ticket',
    unassigned: 'Unassigned',
    status: {
      close: 'Close ticket',
      open: 'Open ticket',
    },
    variant: {
      label: 'Ticket type',
      save: 'Save',
      option: {
        question: 'Question',
        report: 'Report',
      },
    },
    forwardTicket: {
      button: 'Forward to external email',
      subjectPrefix: 'Report: ',
      subjectPrefix_question: 'Question: ',
      bodyArea: 'Missä vika ilmeni?',
      bodyIntro: 'Vikailmoitus luotu {{date}} Boappassa.',
      bodyIntro_question: 'Kysymys luotu {{date}} Boappassa.',
      labelSociety: 'Taloyhtiö',
      labelResident: 'Asukas',
      labelAddress: 'Osoite',
      labelUnit: 'Asunnon nro',
      labelEmail: 'Sähköposti',
      labelMobile: 'Puhelin',
      labelTitle: 'Otsikko',
      labelDescription: 'Kuvaus',
      greeting: 'Ystävällisin terveisin',
      signature: 'Taloyhtiön {{societyName}} hallitus',
      missing: '-',
    },
  },
  reportProblemView: {
    title: 'Virheilmoitus',
    form: {
      labels: {
        title: 'Tehtävän otsikko',
        space: 'Missä virhe tapahtui?',
        message: 'Kuvaile asiaa',
        images: 'Kuvat',
      },
    },
    flashMessage: {
      createReportSuccess: 'Virheraportti lähetetty',
      createReportFailure: 'Virheraporttia ei voitu lähettää',
    },
    helperTexts: {
      contactInformation: 'Yhteystietosi liitetään automaattisesti.',
    },
    errorView: {
      title: 'Sähköposti puuttuu vikailmoituksesta',
      subtitle: 'Aktivoi virheraportti antamalla sähköpostiosoite',
    },
  },
  reportProblemSettings: {
    modal: {
      title: 'Virheilmoituksen asetukset',
    },
    form: {
      headers: {
        recipient: 'Vastaanottaja',
        cc: 'Kopio',
      },
    },
  },
  localOffersView: {
    title: 'Edut',
    emptyState: {
      title: 'Ei etuja',
      subtitle: 'Yhdistys ei ole vielä lisännyt etuja.',
      subtitle_lgh: 'Kiinteistö ei ole vielä lisännyt etuja.',
    },
    modal: {
      create: 'Luo uusi etu',
      update: 'Päivitä etu',
    },
    form: {
      labels: {
        benefit: 'Etu',
        body: 'Kuvaus',
        companyName: 'Yrityksen nimi',
      },
      placeholders: {
        discount: '20 % alennus',
      },
      headers: {
        contactDetails: 'Yhteystiedot',
      },
    },
    flashMessage: {
      createLocalOfferSuccess: 'Etu luotu',
      createLocalOfferFailure: 'Etua ei voitu luoda',
    },
  },
  localOfferView: {
    title: 'Etu',
    confirmationModal: {
      deleteTitle: 'Poista etu',
      deleteDescription: 'Haluatko varmasti poistaa edun?',
    },
    errors: {
      notFound: {
        title: 'Etua ei löytynyt',
        subtitle: 'Yritit saada etua, jota ei ole olemassa.',
      },
    },
    flashMessage: {
      updateLocalOfferSuccess: 'Etu päivitetty',
      updateLocalOfferFailure: 'Etua ei voitu päivittää',
      deleteLocalOfferSuccess: 'Etu poistettu',
      deleteLocalOfferFailure: 'Etua ei voitu poistaa',
    },
  },
  marketplaceDetailView: {
    labels: {
      published: 'Julkaistu',
      createdBy: 'Lähettäjä',
    },
    confirmationModal: {
      deleteTitle: 'Poista mainos',
      deleteDescription: 'Haluatko varmasti poistaa mainoksen?',
    },
    errors: {
      notFound: {
        title: 'Mainosta ei löytynyt',
        subtitle: 'Yritit päästä mainokseen, jota ei ole olemassa.',
      },
    },
    flashMessage: {
      updateListingSuccess: 'Mainos päivitetty',
      updateListingFailure: 'Mainosta ei voitu päivittää',
      deleteListingSuccess: 'Mainos poistettu',
      deleteListingFailure: 'Mainosta ei voitu poistaa',
    },
  },
  createUpdateHouseRuleForm: {
    labels: {
      subject: 'Aihe',
      rule: 'Sääntö',
    },
  },
  invoiceView: {
    title: 'Laskutus',
    subtitle: 'Hallinnoi laskujasi ja maksuvaihtoehtojasi',
    tabBar: {
      payment: 'Maksu',
      details: 'Tiedot',
    },
    neighbourhood: {
      title: 'Naapurusto käyttää Boappaa ilmaiseksi!',
    },
    details: {
      title: 'Laskun tiedot',
      alert: 'Laskut lähetetään sähköpostitse',
      form: {
        labels: {
          recipient: 'Laskun vastaanottaja',
          billingStreet: 'Laskutusosoite',
        },
      },
    },
    basic: {
      remember: 'Muista!',
      payYourAnnualFee: 'Maksa vuosimaksu.',
      locked: {
        title: 'Yhdistys on lukittu.',
        subtitle: 'Maksa vuosimaksu jatkaaksesi Boappan käyttöä.',
        title_lgh: 'Kiinteistö',
      },
    },
    premium: {
      great: 'Hienoa!',
      annualFeePayed: 'Tilauksesi on aktiivinen.',
      paymentPlan: 'Maksusuunnitelma',
      invoiceSentTo: 'Lasku lähetetään osoitteeseen',
      untilNextPayment: 'seuraavaan maksuun asti',
    },
    commonCard: {
      annualFee: 'Vuosimaksu',
      excludingVat: 'Ei sis. alv',
      buttons: {
        useCode: 'Käytä koodia',
      },
      missingEmail: {
        title: 'Sähköpostiosoite puuttuu.',
        description: 'Ennen kuin maksat, sinun on ',
        link: 'päivitettävä sähköpostiosoitteesi',
      },
    },
    accordions: {
      title: 'Aiheeseen liittyviä kysymyksiä',
      premium: {
        sections: {
          discountCode: {
            title: 'Oletko käyttänyt alennuskoodia?',
            text: 'Alennuskoodi on voimassa toistaiseksi ja niin kauan kuin yhteistyö kumppanin kanssa on aktiivista.',
          },
        },
      },
      basic: {
        sections: {
          bostadsratterna: {
            title: 'Asuntoliiton jäsen',
            text: 'Nykyinen alennuskoodi on saatavilla, kun olet kirjautunut sisään Asuntoliiton verkkosivuille. Tarjous on voimassa niin kauan kuin jäsenyys on aktiivinen.',
          },

          samfalligheterna: {
            title: 'Yhteenliittymä',
            text: 'Lähetä sähköpostia samfalligheter@villaagarna.se saadaksesi alennuskoodisi.',
          },
        },
      },
      common: {
        sections: {
          paymentInstructions: {
            title: 'Maksuohjeet',
            preLinkText: 'Lue opas',
          },
          termsOfService: {
            title: 'Palveluehdot',
            preTermsText: 'Palvelu toimitetaan',
            preDataProcessingText: 'ja',
          },
          cancelSubscription: {
            title: 'Lopeta jäsenyys',
            text: 'Ota yhteyttä support@boappa.se, jos haluat lopettaa palvelun.',
          },
        },
      },
    },
    modals: {
      payment: {
        title: 'Maksu',
      },
      discountCode: {
        title: 'Alennuskoodi',
        informationSection: {
          title: 'Mistä löydän alennuskoodin?',
          text: 'Käyttääkseen Boappaa alennuksella yhdistyksen tulee olla Asuntoliiton jäsen. Löydät koodin sisäänkirjautuneena Asuntoliiton sivuilta.',
          text_samf:
            'Saadaksesi 50 % alennuksen Boappasta, yhdistyksesi tulee olla allekirjoittanut turvasopimus Yhteenliittymän (Villaägarnan palvelu) kanssa. Lähetä sähköpostia samfalligheter@villaagarna.se saadaksesi alennuskoodisi.',
        },
      },
    },
    forms: {
      payment: {
        sections: {
          invoiceDetails: 'Laskutustiedot',
          orderInformation: 'Tilaustiedot',
        },
        labels: {
          yearlyCost: 'Vuosimaksun hinta',
          validity: 'Voimassaolo',
        },
        cost: {
          totalCost: 'Kokonaishinta sis. alv.',
          vat: 'Josta ALV',
        },
        agreement: {
          preUserAgreement:
            'Minulla on oikeus liittää yhdistykseni ja hyväksyä se',
          postUserAgreement: 'sis. liitteen',
          userAgreement: 'Käyttöehdot',
          termsOfService: 'Palveluehdot',
          personalDataAgreement: 'Henkilötietojen käsittelysopimus',
          preUserAgreement_lgh:
            'Minulla on oikeus sitoa kiinteistöni ja hyväksyä',
        },
        errors: {
          upgradeErrored:
            'Ei ollut mahdollista tilata. Ota yhteyttä support@boappa.se',
        },
      },
      discountCode: {
        labels: {
          discountCode: 'Syötä alennuskoodisi',
        },
        errors: {
          discountCode: 'Virheellinen alennuskoodi',
        },
        placeholders: {
          discountCode: 'Kirjoita koodi tähän...',
        },
      },
    },
    flashMessage: {
      discountCodeApplied: 'Alennuskoodi on käytetty',
      upgradeSuccess: 'Yhdistys on päivitetty',
    },
  },
  createUpdateHouseRule: {
    addNewHouseRuleTitle: 'Luo uusi sääntö',
    editHouseRuleTitle: 'Muokkaa sääntöä',
    flashMessage: {
      updateHouseRuleSuccess: 'Sääntö päivitetty',
      updateHouseRuleFailure: 'Sääntöä ei voitu päivittää',
      createHouseRuleSuccess: 'Sääntö luotu',
      createHouseRuleFailure: 'Sääntöä ei voitu luoda',
      deleteHouseRuleSuccess: 'Sääntö poistettu',
      deleteHouseRuleFailure: 'Sääntöä ei voitu poistaa',
    },
    confirmationModal: {
      title: 'Poista viihtymisääntö',
      description: 'Haluatko varmasti poistaa säännön?',
    },
  },
  createUpdateQuestionsAndAnswers: {
    addNewQuestionTitle: 'Uusi kysymys',
    editQuestionTitle: 'Muokkaa kysymystä',
    addNewSectionTitle: 'Luo uusi osio',
    editSectionTitle: 'Muokkaa osiota',
    flashMessage: {
      updateQuestionSuccess: 'Kysymys päivitetty',
      updateQuestionFailure: 'Kysymystä ei voitu päivittää',
      createQuestionSuccess: 'Kysymys luotu',
      createQuestionFailure: 'Kysymystä ei voitu luoda',
      deleteQuestionSuccess: 'Kysymys poistettu',
      deleteQuestionFailure: 'Kysymystä ei voitu poistaa',
      updateSectionSuccess: 'Osio päivitetty',
      updateSectionFailure: 'Osiota ei voitu päivittää',
      createSectionSuccess: 'Osio luotu',
      createSectionFailure: 'Osiota ei voitu luoda',
      deleteSectionSuccess: 'Osio poistettu',
      deleteSectionFailure: 'Osiota ei voitu poistaa',
    },
    confirmationModal: {
      title: 'Poista kysymys',
      description: 'Haluatko varmasti poistaa kysymyksen?',
    },
    removeSectionConfirmationModal: {
      title: 'Poista osio',
      description: 'Haluatko varmasti poistaa osion?',
    },
  },
  createUpdateQuestionsAndAnswersItemForm: {
    labels: {
      question: 'Kysymys',
      answer: 'Vastaus',
    },
  },
  createUpdateQuestionsAndAnswersSectionForm: {
    labels: {
      section: 'Otsikko',
    },
  },
  notifications: {
    title: 'Ilmoitukset',
    emptyState: 'Tässä näytetään ilmoitukset sovelluksen tapahtumista.',
    newTicketFromBoard: 'Uusi hallituksen tiketti {% ticketTitle %} on luotu.',
    newTicket: 'Uusi tiketti {% ticketTitle %} on luotu.',
    ticketOpen: 'Tiketti {% ticketTitle %} on avattu.',
    ticketClosed: 'Tiketti {% ticketTitle %} on suljettu.',
    ticketAssigned: 'Sinulle on osoitettu tiketti {% ticketTitle %}.',
    newGroupChat:
      'Ryhmächat nimeltä {% roomName %} on luotu. Katso, mistä keskustellaan.',
    newPost: `{% userName %} loi julkaisun: "{% message %}"`,
    newComment: '{% userName %} kommentoi julkaisua: "{% comment %} "',
    newCommentYourPost: '{% userName %} kommentoi julkaisusi: "{% comment %} "',
    newLike: '{% userName %} tykkäsi julkaisustasi: "{% message %} "',
    newProblemReport: 'Virheraportti on lähetetty sähköpostiosoitteeseesi',
    societyActivated: '{% societyName %} aktivoitu Boappassa!',
    societyInvite: 'Sinut on kutsuttu yhteisöön {% societyName %}',
    societyRequest: '{% userName %} pyytää pääsyä yhteisöön {% societyName %}',
    societyRequestAccepted:
      'Sinulle on myönnetty pääsyoikeus yhteisöön {% societyName %}',
    societyRequestAcceptedAdmin:
      '{% userName %} on saanut pääsyn yhteisöön {% societyName %}',
    newInspiration: 'Lue tämän kuun inspiraatiosta muilta Boappan käyttäjiltä.',
    chatNewChannel:
      'Ryhmächat nimeltä {% roomName %} on luotu. Katso, mistä keskustellaan.',
    contractMonitoring:
      'Sopimuksen seurantapäivä on koittanut {% contractTitle %}',
    newBinderDocument: 'Uusi asiakirja on lisätty kansioon: {% unitName %}',
    newBinderFolder: 'Uusi kansio on luotu bopärmiin: {% unitName %}',
    newBinderInformation: 'Uutta tietoa on lisätty bopärmiin: {% unitName %}',
  },
  searchBar: {
    placeholder: {
      search: 'Etsi...',
      filter: 'Suodata...',
    },
  },
  dropZone: {
    dragFileHere: 'Vedä tiedosto tähän tai',
    clickToSelect: 'napsauta valitaksesi tiedoston',
    acceptedFormats: 'Hyväksytyt tiedostomuodot',
    dragFolderHere: 'Vedä kansio tähän tai',
    folderDescriptionNotePrefix: 'Teksti kansiossa: nimeä tiedosto ',
    folderDescriptionName: 'folderDescription.md',
    folderDescriptionNoteSuffix: ' tai txt.',
    folderThumbnailNotePrefix: 'Kuva kansiossa: nimeä tiedosto ',
    folderThumbnailName: 'folderThumbnail.png',
    folderThumbnailNoteSuffix: ' tai jpeg/jpg/webp.',
    clickToSelectFolder: 'napsauta valitaksesi kansion',
  },
  createUpdateContactModal: {
    addNewContactTitle: 'Luo uusi yhteystieto',
    editContactTitle: 'Muokkaa yhteystietoa',
    flashMessage: {
      updateContactSuccess: 'Yhteystiedot päivitetty',
      updateContactFailure: 'Yhteystietoa ei voitu päivittää',
      createContactSuccess: 'Yhteystieto luotu',
      createContactFailure: 'Yhteystietoa ei voitu luoda',
    },
  },
  createUpdateContractModal: {
    addNewContractTitle: 'Luo uusi sopimus',
    editContractTitle: 'Muokkaa sopimusta',
    flashMessage: {
      updateContractSuccess: 'Sopimus päivitetty',
      updateContractFailure: 'Sopimusta ei voitu päivittää',
      createContractSuccess: 'Sopimus luotu',
      createContractFailure: 'Sopimusta ei voitu luoda',
    },
  },
  createUpdateContractForm: {
    labels: {
      title: 'Otsikko',
      company: 'Yritys',
      description: 'Kuvaus',
      running: 'Voimassa oleva',
      startDate: 'Alkupäivämäärä',
      endDate: 'Päättymispäivämäärä',
      notificationDate: 'Seurantapäivämäärä',
      status: 'Tila',
      documents: 'Asiakirja',
      contactName: 'Nimi',
      contactEmail: 'Sähköpostiosoite',
      contactPhone: 'Puhelinnumero',
      contactWebsite: 'Kotisivu',
    },
    headers: {
      contactDetails: 'Yhteystiedot',
      documents: 'Asiakirja',
    },
    status: {
      active: 'Aktiivinen',
      terminated: 'Valmis',
    },
  },
  createUpdateDocument: {
    addNewDocumentTitle: 'Lataa asiakirja',
    editDocumentTitle: 'Muokkaa asiakirjaa',
    flashMessage: {
      updateDocumentSuccess: 'Asiakirja päivitetty',
      updateDocumentFailure: 'Asiakirjaa ei voitu päivittää',
      createDocumentPluralSuccess: 'Asiakirja luotiin',
      createDocumentPluralFailure: 'Asiakirjaa ei voitu luoda',
      createDocumentSingularSuccess: 'Asiakirja luotu',
      createDocumentSingularFailure: 'Asiakirjaa ei voitu luoda',
      deleteDocumentSuccess: 'Asiakirja poistettu',
      deleteDocumentFailure: 'Asiakirjaa ei voitu poistaa',
    },
    removeDocumentConfirmationModal: {
      title: 'Poista asiakirja',
      description: 'Haluatko varmasti poistaa asiakirjan?',
    },
  },
  createUpdateDocumentForm: {
    labels: {
      name: 'Nimi',
    },
    uploadedFiles: 'Ladatut tiedostot',
  },
  createUpdateBinderForm: {
    filesToBeUploaded: 'Mappar/filer att ladda upp ({{numberOfFiles}})',
  },
  documentsList: {
    allDocuments: 'Kaikki asiakirjat',
    allDocuments_lgh: 'Kaikki kiinteistön tiedot',
    allBoardDocuments: 'Alla styrelsedokument',
    allBoardDocuments_lgh: 'Kaikki isännöitsijän asiakirjat',
    emptyState: {
      noSearchResultSubtitle:
        'Hakutuloksia ei löytynyt. Yritä uudelleen tai muuta hakutermiä.',
      title: 'Sinulla ei ole mitään luettavaa',
      emptyFolderSubtitle:
        'Tällä hetkellä ei ole julkaistuja asiakirjoja kansiossa {{folderName}}". Kun hallitus jakaa raportteja, muistiinpanoja ja asiaankuuluvia asiakirjoja, ne näkyvät täällä.',
      noDocumentsSubtitle:
        'Tällä hetkellä kansioita tai asiakirjoja ei ole julkaistu. Kun hallitus jakaa raportteja, muistiinpanoja ja asiaankuuluvia asiakirjoja, ne näkyvät täällä.',
      emptyFolderSubtitleBoard:
        'Tällä hetkellä ei ole julkaistuja asiakirjoja kansiossa {{folderName}}".',
      noDocumentsSubtitleBoard:
        'Tällä hetkellä kansioita tai asiakirjoja ei ole julkaistu.',
      noDocumentsSubtitle_lgh:
        'Tällä hetkellä kansioita tai asiakirjoja ei ole julkaistu. Kun isännöitsijä jakaa raportteja, muistiinpanoja ja asiaankuuluvia asiakirjoja, ne näkyvät täällä.',
      emptyFolderSubtitle_lgh:
        'Tällä hetkellä ei ole julkaistuja asiakirjoja kansiossa {{folderName}}". Kun isännöitsijä jakaa raportteja, muistiinpanoja ja asiaankuuluvia asiakirjoja, ne näkyvät täällä.',
    },
    document: {
      folderSingular: 'kansio',
      folderPlural: 'kansiot',
      documentSingular: 'asiakirja',
      documentPlural: 'asiakirja',
    },
  },
  binderList: {
    binders: 'Talokansio',
    rootFolderDescription:
      'Tässä näytetään asiakirjat taloyhtiölle {{societyName}}, asunto {{unitNbr}}',
    emptyState: {
      noSearchResultSubtitle:
        'Hakutuloksia ei löytynyt. Yritä uudelleen tai muuta hakutermiä.',
      title: 'Sinulla ei ole mitään luettavaa',
      emptyBinder:
        'Tällä hetkellä ei ole julkaistuja asiakirjoja kansiossa talokansiossa',
      emptyFolderSubtitle:
        'Tällä hetkellä ei ole julkaistuja asiakirjoja kansiossa {{folderName}}".',
      noDocumentsSubtitle:
        'Tällä hetkellä kansioita tai asiakirjoja ei ole julkaistu.',
    },
  },
  createUpdateFolder: {
    addNewFolderTitle: 'Luo uusi kansio',
    editFolderTitle: 'Muokkaa kansiota',
    flashMessage: {
      updateFolderSuccess: 'Kansio päivitetty',
      updateFolderFailure: 'Kansiota ei voitu päivittää',
      createFolderSuccess: 'Kansio luotu',
      createFolderFailure: 'Kansiota ei voitu luoda',
      deleteFolderSuccess: 'Kansio poistettu',
      deleteFolderFailure: 'Kansiota ei voitu poistaa',
    },
    removeFolderConfirmationModal: {
      title: 'Poista kansio',
      description: 'Haluatko varmasti poistaa kansion?',
    },
  },
  createUpdateFolderForm: {
    labels: {
      name: 'Nimi',
      thumbnail: 'Kansikuvake',
    },
  },
  deleteContract: {
    flashMessage: {
      deleteContractSuccess: 'Sopimus poistettu',
      deleteContractFailure: 'Sopimusta ei voitu poistaa',
    },
    removeContractConfirmationModal: {
      title: 'Poista sopimus',
      description: 'Haluatko varmasti poistaa sopimuksen?',
    },
  },
  widgetView: {
    emptyState: {
      title: 'Toimintoa ei löytynyt',
      subtitle: 'Yritit käyttää toimintoa, jota ei ole olemassa.',
    },
  },
  createUpdateAdminModal: {
    addNewAdminTitle: 'Lisää ylläpitäjä',
    flashMessage: {
      adminAddSuccessSingular: 'Ylläpitäjä lisätty',
      adminAddFailureSingular: 'Ylläpitäjää ei voitu lisätä',
      adminAddSuccessPlural: 'Ylläpitäjiä lisätty',
      adminAddFailurePlural: 'Ylläpitäjiä ei voitu lisätä',
    },
  },
  createUpdateBoardMemberModal: {
    addNewBoardMemberTitle: 'Lisää hallituksen jäsen',
    addNewBoardMemberTitle_lgh: 'Lisää isännöitsijä',
    editBoardMemberTitle: 'Muokkaa hallituksen jäsentä',
    editBoardMemberTitle_lgh: 'Muokkaa isännöitsijää',
    flashMessage: {
      createRoleSuccess: 'Rooli on luotu',
      createRoleFailure: 'Roolia ei voitu luoda',
      updateRoleSuccess: 'Roolia on päivitetty',
      updateRoleFailure: 'Roolia ei voitu päivittää',
    },
  },
  createUpdateAdminForm: {
    labels: {
      users: 'Käyttäjä',
    },
    error: {
      minItems: 'Valitse vähintään yksi käyttäjä',
    },
  },
  createUpdateBlockedUserModal: {
    title: 'Lisää esto',
  },
  createUpdateBlockedUserForm: {
    labels: {
      users: 'Käyttäjä',
    },
    error: {
      minItems: 'Valitse vähintään yksi käyttäjä',
    },
  },
  createUpdateBoardMemberForm: {
    labels: {
      role: 'Rooli',
      user: 'Käyttäjä',
    },
  },
  boardListView: {
    title: 'Hallituksen jäsenet',
    title_lgh: 'Isännöitsijät',
    addBoardMember: 'Lisää hallituksen jäsen',
    addBoardMember_lgh: 'Lisää isännöitsijä',
    alert: {
      deleteBoardMemberTitle: 'Poista hallituksen jäsen',
      deleteBoardMemberTitle_lgh: 'Poista isännöitsijä',
      deleteBoardMemberText: 'Haluatko varmasti poistaa hallituksen jäsenen?',
      deleteBoardMemberText_lgh: 'Haluatko varmasti poistaa isännöitsijän?',
    },
    emptyState: {
      title: 'Ei hallituksen jäseniä',
      title_lgh: 'Ei isännöitsijöitä',
      subtitle: 'Hallituksen jäseniä ei ole lisätty yhdistykseen.',
      subtitle_lgh: 'Isännöitsijöitä ei ole lisätty kiinteistöön.',
    },
    flashMessage: {
      deleteBoardMemberSuccess: 'Hallituksen jäsen poistettu',
      deleteBoardMemberSuccess_lgh: 'Isännöitsijä poistettu',
      deleteBoardMemberFailure: 'Hallituksen jäsentä ei voitu poistaa',
      deleteBoardMemberFailure_lgh: 'Isännöitsijää ei voitu poistaa',
    },
  },
  boardListItem: {
    dropdown: {
      editRole: 'Muokkaa roolia',
    },
  },
  createUpdateContactForm: {
    labels: {
      coverPhoto: 'Kansikuva',
      name: 'Nimi',
      title: 'Otsikko',
      description: 'Kuvaus',
      phoneNumber: 'Puhelinnumero',
      emailAddress: 'Sähköpostiosoite',
      website: 'Kotisivu',
    },
    headers: {
      contactDetails: 'Yhteystiedot',
    },
  },
  adminView: {
    title: 'Admin',
    tabBar: {
      users: 'Käyttäjä',
      societies: 'Yhdistykset',
      actions: 'Toiminnot',
      discountCodes: 'Alennuskoodit',
      logInAsUser: 'Kirjaudu sisään käyttäjänä',
      pendingInvoices: 'Odottavat laskut',
      extractData: 'Lataa ote',
      auditLogs: 'Tarkastuslokit',
      webinars: 'Webinaarit',
      societies_lgh: 'Kiinteistöt',
    },
    searchBar: {
      placeholders: {
        users: 'Hae sähköpostiosoitteella tai tunnuksella',
        societies: 'Hae nimellä tai tunnuksella',
        auditLogs: 'Hae yhdistyksen sivuilta',
        auditLogs_lgh: 'Etsi kiinteistön tunnuksella',
      },
    },
    searchResult: {
      emptyResult: 'Ei tulosta.',
    },
  },
  manageHousehold: {
    modalTitle: 'Kutsu henkilöitä',
    title: 'Kotitalous',
    subtitle:
      'Täällä voit kutsua perheenjäseniä, asukkaita ja vuokralaisia, joilla pitäisi olla pääsy sovellukseen, mutta jotka eivät ole yhdistyksen jäseniä.',
    form: {
      headers: {
        household: 'Kotitalouden henkilöt',
        pendingInvites: 'Vastaamattomat kutsut',
      },
    },
    buttons: {
      addPerson: 'Lisää henkilö',
    },
    reminder: {
      confirmationModal: {
        title: 'Lähetä muistutus',
        description:
          'Haluatko lähettää muistutuskutsun osoitteeseen {{ email }}?',
      },
    },
    errorViews: {
      noSociety: {
        title: 'Et ole yhdistyksen jäsen',
        subtitle:
          'Jotta voit hallita kotitalouttasi, sinun on kuuluttava yhdistykseen ja sinulla on oltava oma yksikkö.',
        title_lgh: 'Et ole kiinteistössä',
        subtitle_lgh:
          'Kotitaloutesi hallitsemiseksi sinun on oltava kiinteistössä ja sinulla on oltava määritetty yksikkö.',
      },
    },
    flashMessage: {
      sendInviteSuccess: 'Kutsuttu henkilö',
      sendInviteFailure: 'Kutsua ei voitu lähettää',
      userReminderFailure: 'Muistutusta ei voitu lähettää',
      userReminderSuccess: 'Muistutus lähetetty',
    },
    subtitle_lgh:
      'Täällä voit kutsua perheenjäseniä, asukkaita ja vuokralaisia, joilla tulee olla pääsy sovellukseen, mutta jotka eivät ole kiinteistön jäseniä.',
  },
  postCreateUpdateBase: {
    form: {
      placeholders: {
        message: 'Hei ihana yhdistys....',
        society: 'Valitse yhdistys',
        message_lgh: 'Hei ihana kiinteistö....',
        society_lgh: 'Valitse kiinteistö',
      },
    },
    media: {
      attach: 'Liitä',
      images: 'Kuvat',
      documents: 'Asiakirja',
    },
    attachments: {
      pictures: 'Valokuvasi',
      gallery: 'Kuvaluettelo',
      document: 'Asiakirja',
      event: 'Tapahtuma',
      poll: 'Äänestys',
    },
    roleSheet: {
      admin: 'Admin',
      board: 'Hallitus',
      board_lgh: 'Isännöitsijä',
    },
    visibilitySheet: {
      all: 'Kaikki',
      board: 'Hallitus',
      board_lgh: 'Isännöitsijälle',
      admin: 'Ylläpitäjät',
    },
    navigationHeaders: {
      polls: 'Äänestykset',
      documents: 'Asiakirja',
      events: 'Tapahtumat',
      images: 'Kuvat',
    },
    alert: {
      imageDeleteTitle: 'Poista kuva',
      imageDeleteText: 'Haluatko varmasti poistaa kuvan?',
      documentDeleteTitle: 'Poista asiakirja',
      documentDeleteText: 'Haluatko varmasti poistaa asiakirjan?',
      eventDeleteTitle: 'Poista tapahtuma',
      eventDeleteText: 'Haluatko varmasti poistaa tapahtuman?',
      pollDeleteTitle: 'Poista äänestys',
      pollDeleteText: 'Haluatko varmasti poistaa äänestyksen?',
    },
    flashMessage: {
      updatePostSuccess: 'Julkaisu päivitetty',
      updatePostFailure: 'Julkaisua ei voitu päivittää',
      createPostSuccess: 'Julkaisu luotu',
      createPostFailure: 'Julkaisua ei voitu luoda',
    },
  },
  society: {
    roles: {
      admin: 'Admin',
      board: 'Hallitus',
      board_lgh: 'Isännöitsijä',
    },
    boardRoles: {
      advisor: 'Adjungoitu',
      alternate: 'Varajäsen',
      chairman: 'Puheenjohtaja',
      member: 'Hallituksen jäsen',
      nominatingCommittee: 'Vaalivaliokunta',
      secretary: 'Sihteeri',
      treasury: 'Rahastonhoitaja',
      viceChairman: 'Varapuheenjohtaja',
    },
    postedBy: '(kautta)',
  },
  authenticationSignInView: {
    title: 'Kirjaudu sisään',
    welcome: 'Tervetuloa Boappaan',
    form: {
      labels: {
        email: 'Sähköpostiosoite',
        password: 'Salasana',
      },
      placeholders: {
        email: 'Kirjoita sähköpostiosoitteesi',
      },
    },
    signInButtonTitle: 'Kirjaudu sisään',
    createAccountButtonTitle: 'Luo tili',
    forgotPasswordButtonTitle: 'Unohditko salasanasi?',
    flashMessage: {
      signInFailure: 'Väärä salasana tai sähköpostiosoite',
      signInFailureHint:
        'Unohditko salasanasi, vai etkö ole vielä valinnut sitä?',
    },
  },
  authenticationSignUpView: {
    title: 'Luo tili',
    subTitle:
      'Tässä voit luoda käyttäjätilin Boappa, jos sinulla ei vielä ole sellaista. Tili on henkilökohtainen, joten käytä omaa sähköpostiosoitettasi. Sähköpostiosoite toimii käyttäjätunnuksenasi Boappa ja sitä käytetään kirjautumiseen. Kirjautumisen jälkeen voit perustaa uuden yhdistyksen Boappa ilmaisella kokeilujaksolla tai hakea jäsenyyttä olemassa olevaan Boappa-yhdistykseen.',
    form: {
      labels: {
        name: 'Etunimi',
        surname: 'Sukunimi',
        email: 'Sähköpostiosoite',
      },
      placeholders: {
        name: 'Kirjoita etunimesi',
        surname: 'Kirjoita sukunimesi',
        email: 'Kirjoita yksityinen sähköpostiosoitteesi',
      },
      checkboxText: {
        legalAge: 'Olen 18-vuotias tai minulla on huoltajan suostumus',
        termsOfService:
          'Hyväksyn Boappan {{termsOfUse}} ja olen lukenut Boappan {{privacyPolicy}}',
        termsOfUseTitle: 'Käyttöehdot',
        privacyPolicyTitle: 'Tietosuojakäytännön',
      },
    },
    signUpButtonTitle: 'Luo tili',
    loginButtonTitle: 'Onko sinulla jo tili?',
    loginCTAButtonTitle: 'Kirjaudu sisään',
    forgotPasswordButtonTitle: 'Unohditko salasanasi?',
    subTitle_lgh:
      'Voit tässä luoda käyttäjätilin Boappaan, jos sinulla ei vielä ole sitä. Tili on henkilökohtainen, joten käytä yksityistä sähköpostiosoitettasi. Sähköpostiosoite on käyttäjätunnuksesi Boappassa ja sitä käytetään kirjautumiseen. Kirjautumisen jälkeen voit käynnistää uuden kiinteistön ilmaiselle koejaksoolle Boappassa tai hakea jäsenyyttä olemassa olevaan Boappa-kiinteistöön.',
    flashMessage: {
      verificationEmailSent: 'Sähköposti on lähetetty!',
    },
  },
  authenticationResetPasswordView: {
    title: 'Palauta salasana',
    linkExpiredTitle: 'Linkki ei enää toimi',
    linkExpiredSubtitle:
      'Se on voinut vanhentua, olla jo käytetty tai korvautua uudemmalla. Kirjoita sähköpostiosoitteesi alle, niin lähetämme uuden.',
    form: {
      labels: {
        email: 'Sähköpostiosoite',
        emailConfirmation: 'Toista sähköpostiosoite',
      },
    },
    resetPasswordButtonTitle: 'Palauta salasana',
    confirmationScreen: {
      title: 'Tarkista sähköpostisi',
      preEmailText:
        'Jos osoite on rekisteröity, olemme lähettäneet sähköpostin osoitteeseen:',
      instructionText:
        'Valitse uusi salasana sähköpostin ohjeiden mukaan. Etkö löydä sähköpostia? Tarkista roskapostikansio.',
    },
    flashMessage: {
      passwordResetSuccess: 'Sähköposti on lähetetty!',
      passwordResetFailure: 'Salasanaa ei voitu nollata',
    },
  },
  authenticationRetrievePasswordView: {
    title: 'Palauta salasana',
    subtitle:
      'Valitse tilillesi uusi salasana. Sen jälkeen olet kirjautuneena sisään.',
    form: {
      labels: {
        password: 'Uusi salasana',
      },
    },
    retrievePasswordButtonTitle: 'Vaihda salasana',
    problemsWithLink: 'Eikö linkki toimi?',
    sendNewLink: 'Lähetä uusi linkki',
    flashMessage: {
      passwordResetSuccess: 'Salasana on vaihdettu',
      passwordResetFailure: 'Linkki ei toiminut',
    },
  },
  societyCreateUpdateContactScreens: {
    flashMessage: {
      updateContactSuccess: 'Yhteystiedot päivitetty',
      updateContactFailure: 'Yhteystietoa ei voitu päivittää',
      createContactSuccess: 'Yhteystieto luotu',
      createContactFailure: 'Yhteystietoa ei voitu luoda',
    },
  },
  societyCreateUpdateResourceScreens: {
    flashMessage: {
      updateResourceSuccess: 'Mainos päivitetty',
      updateResourceFailure: 'Mainosta ei voitu päivittää',
      createResourceSuccess: 'Mainos luotu',
      createResourceFailure: 'Mainosta ei voitu luoda',
    },
  },
  createUpdateResourceModal: {
    title: 'Luo uusi mainos',
    labels: {
      media: 'Kuva',
      title: 'Otsikko',
      description: 'Kuvaus',
      cost: 'Hinta',
    },
    placeholders: {
      description: 'Kuvaile mainoksessa olevaa tuotetta',
    },
  },
  settingsView: {
    title: 'Oma tilini',
    tabBar: {
      tabs: {
        myInfo: 'Omat tietoni',
        changePassword: 'Vaihda salasana',
        notificationSettings: 'Ilmoitukset',
      },
    },
  },
  changeLanguage: {
    title: 'Kieli',
  },
  profileSettings: {
    title: 'Tili',
    profilePictureTitle: 'Profiilikuva',
    labels: {
      updateProfilePicture: 'Muuta',
    },
    confirmationModal: {
      title: 'Poista profiilikuva',
      description: 'Haluatko varmasti poistaa profiilikuvan?',
    },
    flashMessage: {
      updateProfilePictureSuccess: 'Profiilikuva päivitetty',
      updateProfilePictureFailure: 'Profiilikuvaa ei voitu päivittää',
      deleteProfilePictureSuccess: 'Profiilikuva poistettu',
      deleteProfilePictureFailure: 'Profiilikuvaa ei voitu poistaa',
    },
    deleteAccount: {
      title: 'Poista tili',
      text: 'Poista tilisi pysyvästi noudattamalla seuraavia ohjeita',
    },
  },
  changeEmail: {
    title: 'Vaihda sähköpostiosoite',
    text: 'Lähetämme vahvistuslinkin uuteen osoitteeseen. Vaihto tulee voimaan vasta, kun avaat linkin.',
    labels: {
      currentEmail: 'Nykyinen sähköpostiosoite',
      newEmail: 'Uusi sähköpostiosoite',
      repeatNewEmail: 'Toista sähköpostiosoite',
    },
    flashMessage: {
      updateEmailFailure: 'Sähköpostiosoitetta ei voitu päivittää',
      updateEmailSuccess: 'Sähköposti on lähetetty!',
    },
  },
  changePassword: {
    title: 'Vaihda salasana',
    labels: {
      currentPassword: 'Nykyinen salasana',
      newPassword: 'Uusi salasana',
    },
    flashMessage: {
      updatePasswordFailure: 'Salasanaa ei voitu päivittää',
      updatePasswordSuccess: 'Salasana päivitetty',
    },
  },
  myInfo: {
    sections: {
      titles: {
        general: 'Yleisiä tietoja',
        work: 'Työ',
        education: 'Koulutus',
        about: 'Minusta',
        interests: 'Kiinnostuksen kohteet',
      },
    },
  },
  boappaSuperadmin: {
    title: 'Tukityökalu',
    userTitle: 'Käyttäjä',
    logout: 'Kirjaudu ulos käyttäjänä',
    signin: 'Kirjaudu sisään käyttäjänä',
    labels: {
      search: 'Hae sähköpostiosoitteella tai tunnuksella',
      searchButton: 'Etsi',
      matches: 'Osumat',
      firstname: 'Etunimi:',
      lastname: 'Sukunimi:',
      verified: 'Vahvistettu sähköpostiosoite:',
      email: 'Sähköpostiosoite:',
    },
  },
  notificationSettings: {
    options: {
      mobile: 'Matkapuhelin',
      email: 'Sähköposti',
    },
    sections: {
      all: {
        title: 'Kaikki ilmoitukset',
        allNotificationsTitle: 'Ota kaikki ilmoitukset pois/päälle',
      },
      admin: {
        title: 'Ylläpitäjä',
        membershipRequestTitle: 'Jäsenyyskyselyt',
      },
      feed: {
        title: 'Fiidi',
        boardNewPostTitle: 'Hallituksen julkaisu',
        boardNewPostTitle_lgh: 'Julkaisut isännöitsijältä',
        boardNewCommentTitle: 'Kommentit hallituksen julkaisuihin',
        boardNewCommentTitle_lgh: 'Kommentit isännöitsijän julkaisuihin',
        neighbourNewPostTitle: 'Julkaisut naapureilta',
        neighbourNewCommentTitle: 'Kommentit naapureiden julkaisuihin',
      },
      chat: {
        title: 'Chat',
        neighbourNewMessageTitle: 'Naapurichat',
        groupNewMessageTitle: 'Ryhmäkeskustelu',
        boardNewMessageTitle: 'Hallitus-chat',
        boardNewMessageTitle_lgh: 'Isännöitsijä-chat',
        questionsNewMessageTitle: 'Kysy hallituksen chatistä',
        questionsNewMessageTitle_lgh: 'Kysy isännöitsijältä chat',
      },
      ticket: {
        title: 'Tiketti',
        forMeAsResidentTitle: 'Minulle asukkaana:',
        forMeInBoardTitle: 'Minulle hallituksessa:',
        newMessageFromBoard: 'Uusi viesti chatissa hallituksen kanssa',
        newTicketFromBoard: 'Uusi tiketti hallitukselta',
        newTicket: 'Uusi tiketti asukkaalta',
        newMessage: 'Uusi viesti chatissa asukkaan kanssa',
      },
    },
  },
  findFriends: {
    numberMatchesSingular: 'Osuma',
    numberMatchesPlural: 'Osumat',
    categories: {
      interests: 'Kiinnostuksen kohteet',
      occupationAndEducation: 'Työ & koulutus',
    },
  },
  form: {
    requiredNote: '*Pakollinen',
    lockedNote: 'Lukittu',
    errors: {
      required: 'Kenttä on pakollinen',
      unknown: 'Väärä arvo',
      invalidEmail: 'Virheellinen sähköpostiosoite',
      invalidWebsite: 'Virheellinen URL-muoto',
      emailConfirmation: 'Sähköpostiosoitteiden on oltava samoja',
      emailSameAsCurrent: 'Tämä on jo tilisi sähköpostiosoite',
      minLength: 'Täytyy olla vähintään {{minLength}} merkkiä',
      minNumber: 'Täytyy olla vähintään {{minNumber}}',
      emailAlreadyInUse: 'Sähköpostiosoite on jo käytössä.',
      matches: 'Väärä muoto',
      organisationNumber:
        'Yritystunnuksessa on oltava 7 numeroa. Esimerkki: 123456-7',
    },
  },
  flashMessage: {
    changesSaved: 'Muutokset tallennettu',
    changesNotSavedError: 'Muutoksia ei voitu tallentaa',
    somethingWentWrongError: 'Jotain meni pieleen',
    tooManyAttemptsError:
      'Liian monta yritystä juuri nyt. Tarkista roskapostikansio ja yritä hetken kuluttua uudelleen.',
    tooManyAttemptsTryLaterError:
      'Liian monta yritystä juuri nyt. Yritä hetken kuluttua uudelleen.',
    somethingWentWrongTryAgainError: 'Jokin meni pieleen. Yritä uudelleen.',
    cannotOpenEmail:
      'Sähköpostiohjelmaa ei voi avata. Lähetä sähköposti osoitteeseen: {% email %}',
    chatSocketError:
      'Jotain meni pieleen viestiä lähetettäessä. Yritä ladata sivu uudelleen tai yritä myöhemmin uudelleen.',
  },
  errorBoundary: {
    errorFallbackTitle: 'Hups, jotain meni pieleen!',
    errorFallbackSubtitle:
      'Virheestä on ilmoitettu kehittäjillemme, ja se korjataan mahdollisimman pian.\n\nVianmäärityksen helpottamiseksi olisimme kiitollisia, jos ilmoitat virheestä.',
    reportBugButtonTitle: 'Ilmoita virheestä',
  },
  user: {
    name: 'Nimi',
    surname: 'Sukunimi',
    gender: 'Sukupuoli',
    phoneNumber: 'Puhelinnumero',
    birthDate: 'Syntymäaika',
    aboutInfo: {
      presentation: 'Esittely',
      presentationPlaceholder: 'Kuvaile itseäsi...',
      interestCategories: 'Luokat',
      occupation: {
        company: 'Yritys',
        title: 'Otsikko',
        industry: 'Teollisuus',
      },
      education: {
        level: 'Taso',
        country: 'Maa',
        institute: 'Instituutti',
        field: 'Koulutus',
        degree: 'Tutkinto',
      },
    },
  },
  education: {
    level: {
      highSchool: 'Lukio',
      professionalSchool: 'Ammattikoulu',
      university: 'Yliopisto',
    },
    degree: {
      bachelor: 'Kandidaatti/korkeakoulu',
      master: 'Maisteri',
      phd: 'Lisensiaatti/lääkäri',
    },
    field: {
      airPilot: 'Lentäjä',
      animalKeeper: 'Eläinten hoitaja',
      architecture: 'Arkkitehtuuri',
      bachelorOfEngineeering: 'AMK-insinööri',
      bioMedicine: 'Lääketieteen analyytikko',
      business: 'Diplomiekonomi',
      civilEngineering: 'Rakennusinsinööri',
      dentalHygiene: 'Hammashygienisti',
      dentist: 'Hammaslääkäri',
      dietetics: 'Ravitsemusterapeutti',
      engineering: 'Rakennusinsinööri',
      environmentalScience: 'Ympäristötieteilijä',
      finance: 'Talous',
      fireScience: 'Pelastaja ja paloteknikko',
      forestry: 'Metsänhoitaja',
      forestEngineering: 'Metsänhoitaja',
      healthScience: 'Terveystieteet',
      hippology: 'Hippologi',
      humanities: 'Humanistiset aineet',
      humanResources: 'Henkilöstöasiantuntija',
      journalism: 'Toimittaja',
      law: 'Juristi',
      libraryAndInformationScience: 'Kirjasto- ja informaatiotieteet',
      logistics: 'Logistiikka',
      marineScience: 'Merikapteeni',
      mediaAndCommunicationScience: 'Media- ja viestintäoppi',
      medicalDoctor: 'Lääkäri',
      natureScience: 'Luonnontieteilijä',
      nursing: 'Sairaanhoitaja',
      occupationalTherapy: 'Toimintaterapeutti',
      optometry: 'Optikko',
      pharmacist: 'Farmaseutti',
      physiotherapy: 'Fysioterapeutti',
      police: 'Poliisi',
      psychology: 'Psykologi',
      realEstate: 'Kiinteistönvälittäjä',
      socialAndBehaviouralScience: 'Käyttäytymistutkija',
      socialScience: 'Yhteiskuntatieteilijä',
      socialWorkEducation: 'Sosionomi',
      softwareDeveloper: 'Web-kehitys ja ohjelmointi',
      statistics: 'Tilastot',
      systemsEngineering: 'Järjestelmäasiantuntija',
      teacher: 'Opettaja',
      theology: 'Teologi',
      veterinary: 'Eläinlääkäri',
    },
  },
  occupation: {
    industry: {
      marketing: 'Myynti, markkinointi, mainonta',
      adminOfficeManagement: 'Toimisto, hallinto',
      healthcare: 'Terveys, sairaanhoito, hoiva',
      customerSupport: 'Asiakaspalvelutyö',
      humanResourcesLegal: 'HR, laki',
      serviceRetailTourism: 'Palvelut, kauppa',
      financeBankingInsurance: 'Talous, rahoitus, vakuutus',
      education: 'Koulutus',
      industryProduction: 'Teollisuus, tuotanto',
      itData: 'IT, data',
      engineering: 'Rakennusinsinööri',
      logisticsPurchasing: 'Osto, Kuljetus, Logistiikka',
      management: 'Hallinto',
      environment: 'Ympäristönsuojelu',
      construction: 'Rakentaminen, suunnittelu',
      cultureMedia: 'Kulttuuri, media',
    },
  },
  interests: {
    actionSports: 'Extreme-urheilu',
    animals: 'Eläimet',
    art: 'Taide',
    boardGames: 'Lautapelit',
    cars: 'Autot',
    cooking: 'Ruoanlaitto',
    dancing: 'Tanssi',
    design: 'Design',
    electronicsSmartHomes: 'Elektroniikka/älykoti',
    entrepreneurship: 'Yrittäjyys',
    family: 'Perhe',
    film: 'Elokuvat',
    fitness: 'Fitness',
    gardening: 'Puutarha/viljely',
    handicraft: 'Käsiteollisuus',
    literature: 'Kirjallisuus',
    motorcycles: 'Moottoripyörät',
    music: 'Musiikki',
    nature: 'Luonto',
    outdoors: 'Ulkoilu',
    painting: 'Maalaus',
    politics: 'Politiikka',
    reading: 'Kirjat',
    religion: 'Uskonto',
    sports: 'Urheilu',
    startups: 'Startupit',
    stockTrading: 'Osakekauppa',
    tech: 'Tekniikka',
    toddlers: 'Lapsiperhe-elämä',
    travel: 'Matkailu',
  },
  genders: {
    male: 'Mies',
    female: 'Nainen',
    other: 'Muu',
  },
  societySideBar: {
    sections: {
      resident: {
        title: 'Asukas',
        neighborhoodTitle: 'Naapurusto',
        residentFunctionsTitle: 'Sinulle asukkaana',
        residentFunctionsTitle_lgh: 'Sinulle asukkaana',
      },
      board: {
        title: 'Hallitusportaali',
        managementTitle: 'Hallitustyö',
        adminTitle: 'Admin',
        title_lgh: 'Hallitusportaali',
        managementTitle_lgh: 'Isännöinti',
      },
    },
    searchBar: {
      placeholder: 'Hae valikosta...',
    },
    items: {
      labels: {
        leaveSociety: 'Poistu yhdistyksestä',
        leaveSociety_lgh: 'Poistu kiinteistöstä',
      },
    },
    callouts: {
      gettingStarted: {
        title: 'Kom igång',
      },
      getToKnow: {
        title: 'Lär känna Boappa',
      },
      incompleteRegister: {
        title: 'Puutteellinen huoneistorekisteri',
        title_samf: 'Puutteellinen kiinteistörekisteri',
      },
      societyLocked: {
        title: 'Yhdistys on lukittu',
        title_lgh: 'Kiinteistö on lukittu',
      },
      societyTrial: {
        titleDays: '{{ days }} päivää kokeilujaksoa jäljellä',
        titleDaysPlural: '{{ days }} päivää kokeilujaksoa jäljellä',
      },
    },
  },
  chatRoomsSidebar: {
    startNewChat: 'Aloita uusi',
    startNewInterestsChat: 'Aloita uusi',
    startNewAskBoardChat: 'Esitä kysymys',
    startNewAskBoardChat_lgh: 'Esitä kysymys',
    startNewBoardChat: 'Aloita uusi',
    startNewBoardChat_lgh: 'Aloita uusi',
    joinGroupChat: 'Liity',
    findQuestionsChat: 'Arkisto',
    message: {
      userSentImageText: 'Lähetit kuvan',
      otherUserSentImageText: '{{name}} lähetti kuvan',
    },
    activeTabBar: {
      resident: 'Asukas',
      board: 'Hallitus',
      board_lgh: 'Isännöitsijä',
    },
    tabs: {
      oneOnOneAndInterestsTitle: 'Chat',
      oneOnOneTitle: 'Naapurit',
      InterestsTitle: 'Ryhmät',
      questionsTitle: 'Kysy hallitukselta',
      questionsTitle_lgh: 'Kysy isännöitsijältä',
      boardTitle: 'Hallitus-chat',
      boardTitle_lgh: 'Isännöitsijä-chatti',
      answerResidentsTitle: 'Vastaa asukkaalle',
    },
    createNewMessage: {
      title: 'Uusi viesti',
    },
    createNewMessageForm: {
      labels: {
        sendTo: 'Vastaanottaja:',
      },
      search: {
        placeholder: 'Kirjoita nimi',
        moreHint: 'Rajaa luetteloa kirjoittamalla',
      },
      error: {
        minItems: 'Valitse vähintään yksi käyttäjä',
      },
    },
  },
  chatRooms: {
    chatDisabled: {
      title: 'Chat pois käytöstä',
      subtitle: 'Hallitus on sulkenut naapureiden välisen chatin',
    },
    userHasNoChats: {
      title: 'Chat ei ole vielä käynnistynyt',
      subtitle:
        'Vinkki: Onko kahvimaito loppu vai unohditko, milloin grillausilta pidetään? Käytä tilaisuutta jutella ja pyytää naapuriltasi apua.',
    },
    userHasNoGroupChats: {
      subtitle:
        'Aloita julkinen tai suljettu ryhmächat naapureidesi kanssa tai tarkista "Liity"-kohdasta, onko sinua kiinnostava chat jo olemassa.',
    },
    ticketEnabledResident: {
      title: 'Ask board has moved',
      title_lgh: 'Ask property manager has moved',
      subtitle:
        'You can now find the function as Tickets under the Society tab',
      subtitle_lgh:
        'You can now find the function as Tickets under the Property tab',
    },
    ticketEnabledBoard: {
      title: 'Answer residents has moved',
      title_lgh: 'Answer residents has moved',
      subtitle:
        'You can now find the function as Ticket management under the Society tab',
      subtitle_lgh:
        'You can now find the function as Ticket management under the Property tab',
    },
    noBoardQuestions: {
      title: 'Ei vielä esitetty kysymystä',
      subtitle:
        'Vinkki: Onko sinulla kysyttävää autotallipaikan jonosta yhdistyksessä? Esitä sitten kysymyksesi hallitukselle täällä.',
      subtitle_lgh:
        'Vinkki: Onko sinulla kysymys siitä, miten jonottaa autotallipaikkaa kiinteistössä? Esitä kysymyksesi isännöitsijälle täällä.',
    },
    noBoardChats: {
      title: 'Hallitus-chat ei ole vielä käynnistynyt',
      title_lgh: 'Isännöitsijä-chattia ei ole vielä aloitettu',
      subtitle:
        'Vinkki: Täällä voit esimerkiksi keskustella meneillään olevista projekteista ja tulevista hallituksen kokouksista.',
      subtitle_lgh:
        'Vinkki: Täällä voitte esimerkiksi keskustella käynnissä olevista projekteista ja tulevista hallituksen kokouksista.',
    },
    noBoardAnswerResidentChats: {
      title: 'Ei vielä esitetty kysymystä',
      subtitle: 'Täällä voit hallituksessa vastata asukkaiden kysymyksiin.',
      subtitle_lgh:
        'Täällä voitte isännöitsijänä vastata asukkaiden kysymyksiin.',
    },
    noChatSelected: {
      title: 'Et ole vielä valinnut keskustelua',
      subtitle:
        'Valitse olemassa oleva keskustelu tai aloita uusi päästäksesi alkuun.',
    },
    pendingRequest: {
      subtitle:
        'Täällä voit keskustella naapureidesi kanssa heti, kun pyyntösi on hyväksytty.',
    },
  },
  chatSettings: {
    actions: {
      add: 'Lisää:',
    },
    actionSheet: {
      changeChatRoomImage: 'Vaihda chat-kuvaa',
      deleteChatRoomImage: 'Poista chat-kuva',
    },
    form: {
      title: 'Ryhmän jäsenet',
      remove: 'Poista chat',
      groupChatName: 'Nimi',
      chatCreator: 'Luonut',
      society: 'Yhdistys',
      type: 'Tyyppi',
      closedGroupChat: 'Suljettu ryhmächat',
      openGroupChat: 'Avaa ryhmächat',
      members: 'Jäsenet',
      showMembers: 'Näytä ryhmän jäsenet',
      noMembersFound: 'Henkilöitä ei löytynyt',
      leave: 'Poistu chatista',
      archive: 'Arkistoi',
      society_lgh: 'Kiinteistö',
    },
    tables: {
      titles: {
        groupChatInfo: 'Ryhmän tiedot',
        addMembers: 'Lisää jäseniä',
        actions: 'Toiminnot',
      },
    },
    alert: {
      chatRoomDeleteTitle: 'Poista chat',
      chatRoomDeleteText: 'Haluatko varmasti poistaa keskustelun?',
      leaveChatRoomTitle: 'Poistu ryhmächatistä',
      leaveChatRoomText: 'Haluatko varmasti poistua ryhmächatistä?',
      archiveChatRoomTitle: 'Arkistoi chat',
      archiveChatRoomText: 'Haluatko varmasti arkistoida chatin?',
      chatRoomMemberDeleteTitle: 'Poista ryhmächatistä',
      chatRoomMemberDeleteText:
        'Haluatko varmasti poistaa tämän henkilön ryhmächatistä?',
    },
    flashMessage: {
      deleteChatRoomSuccess: 'Chat poistettu',
      deleteChatRoomFailure: 'Chattiä ei voitu poistaa',
      leaveChatRoomSuccess: 'Poistui ryhmächatista',
      leaveChatRoomFailure: 'Ryhmächatista ei voitu poistua',
      archiveChatRoomSuccess: 'Chat arkistoitu',
      archiveChatRoomFailure: 'Chattia ei voitu arkistoida',
      deleteChatRoomMemberSuccess: 'Henkilö poistettu',
      deleteChatRoomMemberFailure: 'Henkilöä ei voitu poistaa',
      addChatRoomMembersSuccess: 'Jäsenet lisätty',
      addChatRoomMembersFailure: 'Jäseniä ei voitu lisätä',
    },
  },
  startNewChat: {
    openGroupChat: 'Avaa ryhmächat',
    closedGroupChat: 'Suljettu ryhmächat',
    changeToGroupChat: 'Vaihda ryhmächattiin',
    groupChatInputLabel: 'Ryhmän nimi:',
    boardChatInputLabel: 'Aihe:',
  },
  managementDocumentsView: {
    title: 'Hallituksen asiakirja',
    title_lgh: 'Isännöitsijän asiakirjat',
    addNewFolder: 'Luo uusi kansio',
    editFolder: 'Muokkaa kansiota',
    addNewDocument: 'Lataa asiakirja',
    bostadsratternaFolderStructure: 'Kansiorakenne',
    flashMessage: {
      createBostadsratternaFolderStructureSuccess: 'Kansiorakenne luotu',
      createBostadsratternaFolderStructureFailure:
        'Kansiorakennetta ei voitu luoda',
    },
  },
  managementBinderView: {
    title: 'Talokansio',
    addNewFolder: 'Luo uusi kansio',
    addNewDocument: 'Lataa kansioita alikansioiden ja tiedostojen kanssa',
    uploadFoldersBtn: 'Lataa kansiot',
    uploadDocumentsBtn: 'Lataa asiakirjat',
    addNewDocumentTitle: 'Lataa asiakirjat ja tiedostot',
    editDocumentTitle: 'Muokkaa asiakirjaa',
    flashMessage: {
      publishBinderSuccess: 'Binder published',
      publishBinderFailure: 'Binder could not be published',
      unPublishBinderSuccess: 'Binder unpublished',
      unPublishBinderFailure: 'Binder could not be unpublished',
    },
    uploadThumbnailInvalidType:
      'Only image files (jpg, jpeg, png, webp) can be used as thumbnail images',
    uploadDescriptionInvalidType:
      'Only md and txt files can be used as descriptions',
  },
  unitPickerView: {
    title: 'Valitse yksikkö',
  },
  binderPickerView: {
    title: 'Valitse yksikkö',
    publishButton: 'Julkaise',
    unpublishButton: 'Poista julkaisu',
    uploadButtonFolders: 'Lataa kansiot',
    uploadButtonDocuments: 'Lataa asiakirjat',
    exportCsvButton: 'Vie CSV',
    csv: {
      folder: 'Kansio',
      folderDescription: 'Kansion kuvaus',
      document: 'Asiakirja',
    },
    flashMessage: {
      exportCsvFailure: 'CSV-tiedoston vienti epäonnistui',
    },
    searchBar: {
      placeholder: 'Suodata osoitteen tai asunnon numeron mukaan...',
    },
    table: {
      adress: 'Address',
      aptNumber: 'Apartment number',
      floor: 'Floor',
      area: 'Area',
      room: 'Room',
      folderAndDocs: 'Folders/documents',
      published: 'Published',
    },
    tooltip: {
      title: 'Tiedosto on jo olemassa',
      text_one:
        'Tiedosto on jo olemassa asunnossa: {{units}}.\nTiedosto korvataan, jos jatkat lataamista.',
      text_other:
        'Tiedosto on jo olemassa asunnoissa: {{units}}.\nTiedosto korvataan, jos jatkat lataamista.',
    },
  },
  binderView: {
    title: 'Talokansio',
    addNewFolder: 'Luo uusi kansio',
    addNewDocument: 'Lataa asiakirja',
  },
  documentsView: {
    title: 'Asiakirja',
    addNewFolder: 'Luo uusi kansio',
    editFolder: 'Muokkaa kansiota',
    addNewDocument: 'Lataa asiakirja',
    title_lgh: 'Kiinteistön tiedot',
  },
  unitRoles: {
    member: 'Asukas (omistaja)',
    resident: 'Asukas',
    tentant: 'Vuokralainen',
    relative: 'Sukulainen/ystävä',
    propertyManager: 'Kiinteistönhoitaja',
    customerRepresentative: 'Asiakasvastaava',
    other: 'Muu',
  },
  joinGroupChat: {
    joinHeader: 'Liity ryhmächattiin',
    join: 'Liity',
    details: 'Tiedot',
    backToGroupChats: 'Takaisin ryhmächatteihin',
    flashMessage: {
      joinGroupChatSuccess: 'Liittyi ryhmächattiin',
      joinGroupChatFailure: 'Ryhmächattiin liittyminen epäonnistui',
    },
  },
  publicGroups: {
    header: 'Julkiset ryhmächatit',
    errorViews: {
      noGroups: {
        title: 'Ei julkisia ryhmächatteja, joihin liittyä',
        subtitle:
          'Täällä näkyvät yhdistyksesi julkiset ryhmächatit, joihin et ole vielä liittynyt.',
      },
    },
  },
  findArchivedChats: {
    header: 'Ota arkistoitu chat käyttöön',
    errorViews: {
      noChatRooms: {
        title: 'Ei arkistoituja chatteja',
        subtitle: 'Täällä voit aktivoida uudelleen arkistoidut chattisi.',
      },
    },
    flashMessage: {
      activateArchivedChatSuccess: 'Arkistoitu chat käytössä',
      activateArchivedChatFailure: 'Chattiä ei voitu aktivoida',
    },
  },
  chatAskBoardNewMessage: {
    title: 'Kysy hallitukselta',
    form: {
      labels: {
        subject: 'Aihe',
        message: 'Tiedote',
      },
    },
    media: {
      attachImageButtonLabel: 'Liitä kuva',
      imageHeaderTitle: 'Kuvat',
    },
    flashMessage: {
      sendQuestionSuccess: 'Kysymys lähetetty',
      sendQuestionFailure: 'Kysymystä ei voitu lähettää',
    },
  },
  chatUpload: {
    flashMessage: {
      uploadImageLimitReached: 'Voit ladata vain 10 kuvaa per chat-viesti',
      uploadDocumentLimitReached:
        'Voit lähettää vain 10 asiakirjaa yhtä chat-viestiä kohden',
    },
  },
  societyManagementWebsiteImages: {
    title: 'Kuvat',
    headers: {
      primaryImageTitle: 'Pääkuva',
      societyImagesTitle: 'Sivuilla näytettävät kuvat',
    },
    addImagesButton: 'Lisää kuva',
    addImageDescription: 'Lisää kuvaus',
    showImagesLabel: 'Näytä',
    recommendedPrimaryImageSizeText:
      'Suositeltu vähimmäiskuvakoko: 1280x800 pikseliä',
  },
  mediaGallery: {
    imageGalleryPositionLabel: 'Kuva',
    imageDownloadSuccessText: 'Kuva ladattu',
    downloadImageButtonText: 'Lataa kuva',
  },
  leaveSociety: {
    confirmationModal: {
      title: 'Poistu yhdistyksestä',
      description: 'Oletko varma, että haluat erota yhdistyksestä?',
      title_lgh: 'Poistu kiinteistöstä',
      description_lgh: 'Haluatko varmasti poistua kiinteistöstä?',
    },
    unableToLeaveModal: {
      title: 'Et voi poistua yhdistyksestä',
      description:
        'Jos haluat poistua yhdistyksestä, sinun on ensin luovutettava pääkäyttäjän rooli jollekin toiselle.',
      title_lgh: 'Et voi poistua kiinteistöstä',
      description_lgh:
        'Poistuaksesi kiinteistöstä sinun on ensin luovutettava pääkäyttäjän rooli jollekulle toiselle.',
    },
    flashMessage: {
      leaveSocietySuccess: 'Yhdistyksestä poistuttu',
      leaveSocietyFailure: 'Yhdistyksestä ei voitu poistua',
      leaveSocietySuccess_lgh: 'Kiinteistöstä poistuttu',
      leaveSocietyFailure_lgh: 'Kiinteistöstä ei voitu poistua',
    },
  },
  reportProblemSpace: {
    apartment: 'Huoneisto',
    building: 'Rakennus',
    surroundings: 'Alue',
    commonAreas: 'Yhteiset tilat',
    other: 'Muu',
  },
  pollEditor: {
    form: {
      labels: {
        title: 'Kysymys',
        type: 'Äänestystyyppi',
      },
      placeholders: {
        option: 'Vaihtoehto',
      },
      headers: {
        options: 'Vastausvaihtoehto',
      },
      buttons: {
        addMoreOptionsButtonTitle: 'Lisää vastausvaihtoehtoja',
        exportVotesButtonTitle: 'Lataa äänet',
      },
    },
    label: {
      perUser: 'Per käyttäjä',
      perHousehold: 'Kotitaloutta kohden',
    },
    pollDescription: 'Äänestys',
  },
  poll: {
    votesSingular: 'ääni',
    votesPlural: 'ääntä',
    showResults: 'Näytä tulokset',
    vote: 'Äänestä',
    regretVote: 'Kumoa äänestys',
    householdAlreadyVoted: 'Kotitaloutesi on jo äänestänyt',
    userAlreadyVoted: 'Olet jo äänestänyt',
    anonymousVoting: 'Anonyymi äänestys',
    nonAnonymousVoting: 'Ei anonyymi äänestys',
    flashMessage: {
      updatePollSuccess: 'Äänestys päivitetty',
      updatePollFailure: 'Äänestystä ei voitu päivittää',
      createPollSuccess: 'Äänestys luotu',
      createPollFailure: 'Äänestystä ei voitu luoda',
      exportVotesFailure: 'Äänien lataaminen epäonnistui',
    },
    csv: {
      option: 'Vaihtoehto',
      votes: 'Äänet',
      name: 'Nimi',
      unit: 'Asunto',
    },
    result: 'Tulokset',
  },
  createSocietyTypeSelectionView: {
    title: 'Luo yhdistys',
    header: 'Näin helposti pääset alkuun yhdistyksesi kanssa',
    paragraph:
      'Sinä, joka edustat yhdistyksesi hallitusta, voit helposti rekisteröidä yhdistyksesi Boappa. Tämän jälkeen voitte kokeilla Boappa kaikkine sen toimintoineen 60 päivän ajan maksutta ja ilman sitoumuksia. Oletamme, että varaatte aikaa ja teette vakavan yrityksen tutustua Boappa.',
    paragraph2:
      'Jos kohtaatte haasteita, tiedätte että teemme kaikkemme, jotta pääsette parhaalla mahdollisella tavalla alkuun. Löydätte runsaasti oppaita <GuideLink>Tietopankistamme</GuideLink>, ja voitte mielellään varata paikan verkkokoulutuksiin Boappa Esittely ja Boappa Käynnistys <DemoLink>täällä</DemoLink>, tai ottaa yhteyttä <SupportLink>tukeemme</SupportLink>.',
    paragraph3: 'Minkä tyyppisen yhdistyksen haluat aktivoida?',

    labels: {
      housingCooperative: 'Asunto-osakeyhtiö, asumisyhdistys',
      homeownersAssociation: 'Kiinteistöyhteisö tai tiekunta',
      realEstateDeveloper: 'Asuinrakennushanke',
      neighbourhood: 'Naapurusto',
    },
    findSociety:
      'Haluatko sen sijaan liittyä yhdistykseen? Hae jäsenyyttä <Link>täällä</Link>',
    title_lgh: 'Luo kiinteistö',
    header_lgh: 'Näin helposti pääset alkuun kiinteistösi kanssa',
    paragraph_lgh:
      'Sinä, joka edustat kiinteistösi hallitusta, voit helposti rekisteröidä kiinteistönne Boappaan. Sen jälkeen saatte kokeilla Boappaa kaikilla sen toiminnoilla 60 päivän ajan ilman kustannuksia ja ilman lisävelvoitteita. Oletamme, että varaatte aikaa ja teette vakavan yrityksen tutustua Boappaan.',
    paragraph3_lgh: 'Minkä tyyppisen kiinteistön haluat aktivoida?',
    findSociety_lgh:
      'Haluatko sen sijaan liittyä kiinteistöön? Hae jäsenyyttä <Link>täältä</Link>',
  },
  societyInviteBanner: {
    invited: 'Sinut on kutsuttu yhteisöön {{societyName}}',
    details: 'Katso kutsu',
  },
  reportPost: {
    title: 'Ilmoita julkaisu',
    subtitle:
      'Boappan tavoitteena on auttaa parantamaan naapuruston harmoniaa. Häirintä ei ole sallittua. Ilmoita ylläpitäjälle julkaisuista, jotka eivät noudata tätä.',
    form: {
      labels: {
        message: 'Tiedote',
      },
    },
    flashMessage: {
      reportSuccess: 'Julkaisusta on ilmoitettu',
      reportFailure: 'Julkaisusta ei voitu ilmoittaa',
    },
    buttons: {
      submitTitle: 'Ilmoita',
    },
  },
  societyRoot: {
    subtitle: 'Täältä löydät pikakuvakkeet yhdistyksesi eri toimintoihin',
    shortcutTitle: 'Pikanäppäimet',
    offersTitle: 'Tarjoukset',
    titles: {
      residentList: 'Asukasluettelo',
      boardDocuments: 'Hallituksen asiakirja',
      boardDocuments_lgh: 'Isännöitsijän asiakirjat',
      register: 'Rekisteröidy',
      societyWebsite: 'Yhdistyksen nettisivut',
      societyWebsite_lgh: 'Kiinteistön verkkosivusto',
    },
    subtitles: {
      residentList: 'Täältä näet, ketä yhdistyksessäsi asuu',
      residentList_lgh: 'Täällä näet, ketkä asuvat kiinteistössäsi',
      boardDocuments: 'Luo kansioita ja lataa asiakirjoja',
      boardDocuments_lgh: 'Luo kansioita ja lataa asiakirjoja',
      register:
        'Kutsu naapureita, hallinnoi osoitteita ja huoneistojen numeroita',
      societyWebsite: 'Muokkaa uutta verkkosivustoasi toiveidesi mukaan',
    },
    onboardingButtonTitle: 'Löydät helposti takaisin oppaaseen täältä',
    subtitle_lgh: 'Täällä löydät pikanäppäimet kiinteistösi eri toimintoihin',
  },
  onboardingView: {
    title: 'Tervetuloa {{societyName}}!',
    subtitle: 'Aloita käyttö yhdistyksesi kanssa',
    explanationTitle:
      'Tämä opas antaa sinulle käsityksen siitä, kuinka navigointi toimii Yhdistys-välilehdellä',
    explanationText:
      'Käymme läpi asiakirjoja, rekisteröintiä, kysymyksiä ja vastauksia sekä yhdistyksen verkkosivuja. Pääset helposti takaisin oppaaseen napsauttamalla yhdistyksen kotisivulla olevaa painiketta.',
    explanationText_lgh:
      'Käymme läpi asiakirjoja, rekisteröintiä, kysymyksiä ja vastauksia sekä kiinteistön verkkosivuja. Pääset helposti takaisin oppaaseen napsauttamalla kiinteistön kotisivulla olevaa painiketta.',
    skipText: 'Selvä? Ohita opas napsauttamalla',
    onboardingSections: {
      documents: {
        title: 'Hallituksen asiakirja',
        title_lgh: 'Isännöitsijän asiakirja',
        subtitle:
          'Lataa asiakirjoja, jotka on jaettu yhdistyksellesi. Voit luoda oman ensimmäisen kansion napsauttamalla "luo kansio" tai "lähetä asiakirjat" aloittaaksesi.',
        subtitle_lgh:
          'Lataa asiakirjoja, jotka on jaettu kiinteistöllesi. Voit luoda oman ensimmäisen kansion napsauttamalla "luo kansio" tai "lähetä asiakirjat" aloittaaksesi.',
      },
      register: {
        title: 'Rekisteröidy',
        subtitle:
          'Kutsu hallituskollegasi ja naapurisi mukaan. Napsauta "Kutsu jäseniä" -painiketta rekisterin sisällä aloittaaksesi kutsuprosessin. Voit myös ladata useita osoitteita kerralla Excel-tiedoston avulla.',
        subtitle_lgh:
          'Kutsu isännöitsijäkollegasi ja vuokralaiset mukaan. Napsauta "Kutsu vuokralaisia" -painiketta rekisterin sisällä aloittaaksesi kutsuprosessin. Voit myös ladata useita osoitteita kerralla Excel-tiedoston avulla.',
      },
      faq: {
        title: 'Kysymyksiä ja vastauksia',
        subtitle:
          'Julkaise hyviä ja hyödyllisiä tietoja, jota naapurisi yhdistyksessä voivat hyödyntää. Täällä voit syöttää esimerkiksi parvekkeista, ulko- ja sisätiloista tietoa, joka on hyvä tietää.',
        subtitle_lgh:
          'Julkaise hyvää ja hyödyllistä tietoa, jota kiinteistössäsi olevat naapurisi voivat käyttää. Täällä voit esimerkiksi antaa tietoa parvekkeista, ulko- ja sisätiloista, joka on hyvä tietää.',
      },
      societyWebsite: {
        title: 'Yhdistyksen nettisivut',
        subtitle:
          'Syötä tiedot ja kuvat omaa yhdistyksesi verkkosivustoa varten. Tänne voit ladata vuosiraportteja, asiakirjoja ja kuvia, jotka liittyvät yhdistyksesi kannalta. Tämä voi myös helpottaa välittäjien työtä, kun heidän on löydettävä tietoja tietystä yhdistyksestäsi.',
        title_lgh: 'Kiinteistön verkkosivusto',
        subtitle_lgh:
          'Anna tietoja ja kuvia täysin omalle kiinteistön verkkosivustollenne. Täällä voitte ladata vuosikertomuksia, asiakirjoja ja kuvia, jotka liittyvät juuri teidän kiinteistöönne. Tämä voi myös helpottaa välittäjiä, kun heidän on löydettävä tietoja juuri teidän kiinteistöstänne.',
      },
    },
    subtitle_lgh: 'Kom igång med din kiinteistö',
    explanationTitle_lgh:
      'Tämä opas antaa sinulle käsityksen siitä, miten navigointi toimii Kiinteistö-välilehdellä',
  },
  onboardingSection: {
    step: 'Vaihe {{step}}',
    nextStep: 'Seuraava vaihe',
    previousStep: 'Edellinen vaihe',
    lastStep: 'Selvä! Sulje opas',
  },
  gettingStartedCompletedScreen: {
    title: 'Grattis! Nu är ni igång med Boappa på riktigt',
    description:
      'Utforska nu på egen hand och se till att medlemmarna aktiverar sig.',
    button: 'Börja Boappa!',
    restartGuide:
      'Skulle ni vilja starta om Kom igång med Boappa-guiden, hittar ni den under Styrelseportalen -> Admin -> Kom igång med Boappa',
  },
  getToKnowCompletedScreen: {
    title: 'Härligt! Nu har ni provat på Boappas kommunikationsverktyg',
    description:
      'Är ni redo att förbereda och köra igång Boappa för hela föreningen? Häng då med i nästa guide',
    button: 'Kom igång med Boappa',
    restartGuide:
      'Skulle ni vilja starta om Lär känna Boappa-guiden, hittar ni den under Styrelseportalen -> Admin -> Lär känna Boappa',
    description_lgh:
      'Oletteko valmiita valmistelemaan ja käynnistämään Boappan koko kiinteistölle? Seuraa seuraavaa opasta',
  },
  getToKnowScreen: {
    title: 'Lär känna Boappa - på 5 minuter',
    description:
      'Som administratör kan du snabbt komma igång med Boappas kommunikationsverktyg i några enkla steg',
    completedView: {
      description:
        'Om ni behöver friska upp minnet kan ni köra om Lär känna boappa guiden igen',
      button: 'Starta lär känna boappa guiden',
      description_lgh:
        'Jos tarvitsette muistin virkistämistä, voitte käydä läpi Tutustu Boappaan -oppaan uudelleen',
    },
    startGuide: {
      title: 'Lär känna Boappa - på 5 minuter',
      description:
        'Som administratör i föreningen är det viktigt att du känner till hur Boappas kommunikationsverktyg fungerar. I denna guide går vi igenom de viktigaste funktionerna.',
      button: 'Starta guiden',
      description_lgh:
        'Kiinteistön järjestelmänvalvojana on tärkeää, että tiedät, miten Boappan viestintätyökalut toimivat. Tässä oppaassa käymme läpi tärkeimmät toiminnot.',
    },
    screens: {
      button: {
        complete: 'Slutför steg',
        undo: 'Ångra steg',
      },
      board: {
        title: 'Bjud in styrelsekollegorna',
        title_lgh: 'Kutsu isännöitsijäkollegat',
        description:
          'Klicka på "Bjud in medlem" uppe till höger och bjud in dina styrelsekollegor',
        description_lgh:
          'Napsauta "Kutsu jäsen" oikeassa yläkulmassa ja kutsu isännöitsijäkollegasi',
      },
      feed: {
        title: 'Skapa ett inlägg i flödet',
        description:
          'Klicka på "Skriv ett inlägg..." och skapa ett inlägg i flödet',
      },
      chat: {
        title: 'Chatta med styrelsen',
        title_lgh: 'Keskustele isännöitsijän kanssa',
        description:
          'Klicka på menyn "Styrelse" och därefter på "+ Starta ny", skriv in ett Ämne -> skriv ett meddelande -> skicka (pilen till höger)',
        description_lgh:
          'Napsauta "Isännöitsijä"-valikkoa ja sitten "+ Aloita uusi", kirjoita aihe -> kirjoita viesti -> lähetä (nuoli oikealla)',
      },
      calendar: {
        title: 'Skapa en kalenderhändelse',
        description: 'Lägg in ert nästa styrelsemöte i styrelsekalendern',
        description_lgh:
          'Lisää seuraava isännöitsijäkokouksenne isännöitsijäkalenteriin',
      },
    },
    todosCompleted: {
      title: 'Bra jobbat!',
      description: 'Nu har du lärt känna Boappas kommunikationsverktyg',
      button: 'Avsluta guiden',
    },
    progress: '{{completed}} av {{total}} steg klara',
    todos: {
      board: {
        title: 'Bjud in styrelsekollegorna',
        title_lgh: 'Kutsu isännöitsijäkollegat',
        description: 'Testa Boappa tillsammans med dina styrelsekollegor',
        description_lgh:
          'Testaa Boappaa yhdessä isännöitsijäkollegoidesi kanssa',
      },
      feed: {
        title: 'Skapa ett inlägg i flödet',
        description:
          'Som styrelse och admin kan du även bifoga dokument, kalenderhändelser och omröstningar i flödet',
        description_lgh:
          'Isännöitsijänä ja järjestelmänvalvojana voit myös liittää asiakirjoja, kalenteritapahtumia ja äänestyksiä fiidiin',
      },
      chat: {
        title: 'Chatta med styrelsen',
        title_lgh: 'Keskustele isännöitsijän kanssa',
        description:
          'Chatta med dina styrelsekollegor genom att skapa en ny chatt och ge chatten ett ämne',
        description_lgh:
          'Keskustele isännöitsijäkollegoidesi kanssa luomalla uusi chatti ja antamalla chatille aihe',
      },
      calendar: {
        title: 'Skapa en kalenderhändelse',
        description: 'Lägg in ert nästa styrelsemöte i styrelsekalendern',
        description_lgh:
          'Lisää seuraava isännöitsijäkokous isännöitsijän kalenteriin',
      },
    },
  },
  gettingStartedScreen: {
    navigation: 'Kom igång med Boappa',
    title: 'Kom igång med Boappa - på riktigt!',
    description:
      'Som administratör kan du förbereda och köra igång Boappa för hela föreningen i några enkla steg',
    startGuide: {
      title: 'Kom igång med Boappa - på riktigt!',
      description:
        'I denna guide går vi igenom de viktigaste stegen för att komma igång med Boappa.',
      button: 'Starta guiden',
      description_lgh:
        'Tässä oppaassa käymme läpi tärkeimmät vaiheet Boappan käynnistämiseksi.',
    },
    completedView: {
      description:
        'Om ni behöver friska upp minnet kan ni köra om kom igång guiden igen',
      button: 'Starta om kom igång guiden',
      description_lgh:
        'Jos tarvitsette muistin virkistämistä, voitte käydä läpi aloitusoppaan uudelleen',
    },
    todosCompleted: {
      title: 'Bra jobbat!',
      description: 'Nu är er förening redo!',
      description_lgh: 'Nyt kiinteistönne on valmis!',
      button: 'Avsluta guiden',
    },
    progress: '{{completed}} av {{total}} steg klara',
    screens: {
      button: {
        complete: 'Slutför steg',
        undo: 'Ångra steg',
      },
      billing: {
        title: 'Aktivera abonnemanget',
        description:
          'Uppdatera faktureringsuppgifterna under fliken Uppgifter. Gå sen tillbaka till Betalning och klicka på betala',
      },
      register: {
        title: 'Skapa ett lägenhetsregister via knappen uppe till höger',
        title_samf: 'Skapa ett fastighetsregister via knappen uppe till höger',
        description:
          'Ladda ner mallen för Lägenhetsregistret via knappen, fyll i enligt instruktionerna och ladda upp på samma ställe.',
        description_samf:
          'Ladda ner mallen för Fastighetsregistret via knappen, fyll i enligt instruktionerna och ladda upp på samma ställe.',
      },
      functions: {
        title: 'Se över funktioner',
        description:
          'Gå igenom och välj vilka funktioner ni vill använda i Boappa, det kostar inget extra',
      },
      members: {
        title: 'Bjud in medlemmarna',
        description:
          'Ladda ner medlemsregistret, uppe till höger, fyll i enligt instruktioner och ladda upp på samma ställe. När du laddar upp medlemsregistret i Boappa då mejlas en inbjudan till samtliga mejladresser. För enskilda inbjudningar använda knappen "Bjud in medlem"',
        title_lgh: 'Kutsu vuokralaiset',
        description_lgh:
          'Lataa jäsenrekisteri, oikeassa yläkulmassa, täytä ohjeiden mukaan ja lataa samaan paikkaan. Kun lataat jäsenrekisterin Boappaan, kutsu lähetetään sähköpostitse kaikille sähköpostiosoitteille. Käytä "Kutsu jäsen" -painiketta yksittäisiin kutsuihin.',
      },
    },
    todos: {
      billing: {
        title: 'Aktivera abonnemanget',
        description:
          'Uppdatera faktureringsuppgifterna och kör igång ert årsabonnemang',
      },
      society_image: {
        title: 'Föreningens bild',
        title_lgh: 'Kiinteistön kuva',
        description:
          'Lägg till en bild på er förening. Den kommer visas här och som profilbild på era inlägg i flödet',
        description_lgh:
          'Lisää kuva kiinteistöstäsi. Se näkyy täällä ja profiilikuvana syötteen viesteissä.',
      },
      register: {
        title: 'Lägenhetsregister',
        title_samf: 'Fastighetsregister',
        description:
          'Första gången du skapar ett lägenhetsregister kan du använda vår importfil (Excel)',
        description_samf:
          'Första gången du skapar ett fastighetsregister kan du använda vår importfil (Excel)',
      },
      functions: {
        title: 'Funktioner',
        description:
          'Välj först vilka funktioner som ni vill använda för föreningsmedlemmarna. Gå sedan in under För dig som boende och förbered  respektive funktion med information',
        description_lgh:
          'Valitse ensin, mitä toimintoja haluat käyttää vuokralaisille. Siirry sitten kohtaan "Asukkaalle" ja valmistele kunkin toiminnon tiedot.',
      },
      members: {
        title: 'Bjud in medlemmarna',
        description:
          'Första gången du skapar ett medlemsregister kan du använda vår importfil (Excel)',
        title_lgh: 'Kutsu vuokralaiset',
        description_lgh:
          'Ensimmäisellä kerralla, kun luot jäsenrekisterin, voit käyttää tuontitiedostoamme (Excel)',
      },
    },
    description_lgh:
      'Järjestelmänvalvojana voit valmistella ja käynnistää Boappan koko kiinteistölle muutamalla yksinkertaisella vaiheella',
  },
  confirmEmailChangeView: {
    title: 'Vahvista sähköpostiosoite',
    pending: {
      title: 'Vahvistetaan uutta sähköpostiosoitettasi',
    },
    success: {
      title: 'Sähköpostiosoitteesi on vaihdettu',
      subtitle:
        'Tällä osoitteella kirjaudut nyt sisään, ja tähän lähetämme kaiken. Aiempi osoitteesi ei enää toimi.',
    },
    failure: {
      title: 'Linkki ei toiminut',
      subtitle:
        'Se on voinut vanhentua, olla jo käytetty tai korvautua uudemmalla pyynnöllä. Mitään ei ole muuttunut — tilisi käyttää edelleen aiempaa sähköpostiosoitettaan. Kirjaudu sisään ja pyydä vaihtoa uudelleen saadaksesi uuden linkin.',
    },
    limited: {
      title: 'Liian monta yritystä juuri nyt',
      subtitle: 'Linkki toimii edelleen. Odota hetki ja yritä uudelleen.',
    },
    continueButtonTitle: 'Jatka Boappaan',
    loginButtonTitle: 'Kirjaudu sisään',
  },
  verifyEmailView: {
    title: 'Tarkista sähköpostisi',
    subtitle:
      'Napsauta lähettämässämme sähköpostissa olevaa linkkiä, valitse salasana ja pääset alkuun. Etkö löydä sähköpostia? Tarkista ensin roskapostikansio, muuten lähetämme uuden alta.',
    linkExpiredTitle: 'Linkki ei enää toimi',
    linkExpiredSubtitle:
      'Se on voinut vanhentua, olla jo käytetty tai korvautua uudemmalla. Kirjoita sähköpostiosoitteesi alle, niin lähetämme uuden.',
    form: {
      labels: {
        email: 'Sähköpostiosoite',
      },
    },
    sendAgain: 'Lähetä linkki uudelleen',
    invalidEmail: 'Annoitko väärän sähköpostiosoitteen?',
    setPassword: {
      title: 'Valitse salasana',
      subtitle:
        'Viimeinen vaihe: valitse tilillesi salasana. Sen jälkeen sinut kirjataan sisään.',
      passwordLabel: 'Salasana',
      submitButtonTitle: 'Tallenna salasana ja kirjaudu sisään',
      flashMessage: {
        success: 'Tervetuloa Boappaan!',
        failure: 'Linkki ei toiminut',
      },
    },
    flashMessage: {
      resendVerifyEmailSuccess: 'Sähköposti on lähetetty!',
      resendVerifyEmailFailure: 'Sähköpostia ei voitu lähettää',
    },
    startOverButtonTitle: 'Aloita tästä',
  },
  deleteAccountModal: {
    title: 'Poista tili',
    warningTitle: 'Oletko varma?',
    warningSubtitle: 'Tilisi poistetaan pysyvästi',
    secondWarningTitle: 'Poista tili',
    secondWarningText:
      'Tili poistetaan pysyvästi, eikä sitä voi palauttaa. Vahvista valintasi napsauttamalla Jatka.',
    lastWarningTitle:
      'Anna salasanasi ja napsauta sitten "Poista tili" poistaaksesi tilisi pysyvästi',
    warningText:
      'Jos päätät poistaa tilisi, sitä ei voi palauttaa. Jos olet muuttanut, voit sen sijaan valita "Poistu yhdistyksestä".',
    canNotDeleteTitle: 'Tiliäsi ei voi poistaa',
    canNotDeleteText:
      'Ennen kuin voit poistaa tilisi, sinun on ensin luovutettava pääkäyttäjän rooli jollekin muulle alla luetelluista yhdistyksistä.',
    alert: {
      deleteAccountTitle: 'Poista tili',
      deleteAccountText:
        'Tili poistetaan pysyvästi, eikä sitä voi palauttaa. Vahvista valintasi.',
    },
    flashMessage: {
      confirmPasswordFailure: 'Väärä salasana',
      deleteAccountSuccess: 'Tilisi on poistettu',
    },
    warningText_lgh:
      'Jos päätät poistaa tilisi, sitä ei voi palauttaa. Jos olet muuttanut, voit sen sijaan valita "Poistu kiinteistöstä".',
    canNotDeleteText_lgh:
      'Sinun on ensin luovutettava pääkäyttäjän rooli jollekulle toiselle alla luetelluissa kiinteistöissä ennen kuin voit poistaa tilisi.',
  },
  uploadImage: {
    invalidImageType:
      'Väärä kuvamuoto, kokeile toista kuvaa tai kuvaformaattia',
  },
}

export default fi
